window.debug=function(){function n(n){!e||!o&&i&&i.log||e.apply(r,n)}function t(n){return a>0?a>n:f.length+a<=n}for(var e,o,r=this,l=Array.prototype.slice,i=r.console,u={},a=9,f=["error","warn","info","debug","log"],c="assert clear count dir dirxml exception group groupCollapsed groupEnd profile profileEnd table time timeEnd trace".split(" "),p=c.length,g=[];--p>=0;)!function(n){u[n]=function(){0!==a&&i&&i[n]&&i[n].apply(i,arguments)}}(c[p]);for(p=f.length;--p>=0;)!function(e,o){u[o]=function(){var u=l.call(arguments),a=[o].concat(u);g.push(a),n(a),i&&t(e)&&(i.firebug?i[o].apply(r,u):i[o]?i[o](u):i.log(u))}}(p,f[p]);return u.setLevel=function(n){a="number"==typeof n?n:9},u.setCallback=function(){var t=l.call(arguments),r=g.length,i=r;for(e=t.shift()||null,o="boolean"==typeof t[0]?t.shift():!1,i-="number"==typeof t[0]?t.shift():r;r>i;)n(g[i++])},u}();

/*
|--------------------------------------------------------------------------
| Ads
|--------------------------------------------------------------------------
*/

/*
	

	

	
|--------------------------------------------------------------------------
| GetURLParameter: Utilities
|--------------------------------------------------------------------------
*/
/**
 * @namespace -- Retrive URL parameter  
 */
__gh__webApp.utilities.GetURLParameter = {
	
	/**
	 * Initialize
	 */
	"init": function(sParam){

		    var sPageURL = window.location.search.substring(1);
		    var sURLVariables = sPageURL.split('&');
		    for (var i = 0; i < sURLVariables.length; i++) 
		    {
		        var sParameterName = sURLVariables[i].split('=');
		        if (sParameterName[0] == sParam) 
		        {
		            return sParameterName[1];
		        }
		    }	
	}

};


/**
 * @namespace
 */
__gh__webApp.ads = __gh__webApp.ads || {};


/**
 * DFP @namespace
 //Global DFP variables
var googletag=googletag||{},
gptAdSlots=[],
dfpIsLoaded = false, // Keep track of if we've already tried to load gpt.js before
dfpFirstLevelAdUnit= __gh__coreData["3rdPartyData"].ads.dfp.firstLevelAdUnit;
dfpSecondLevelAdUnit='',
krux_catlist='',
defaultSlotsJSON=defaultSlotsJSON||'',
__gh__articlePage_articleLoaded=false;
__gh__coreData["3rdPartyData"].ads.dfp.topBarSponsor
 */

/*
|--------------------------------------------------------------------------
| Ads: DFP
|--------------------------------------------------------------------------
Avoid race conditions by making sure to respect the usual timing of GPT. Example valid partial orderings include:
**Define-Enable-Display**
	Define page-level settings
	Define slots
	enableServices()
	Display slots

------->**Enable-Define-Display**<---- Method used below
	Define page-level settings
	enableServices()
	Define slots
	Display slots
*/


/*
|------------------------------------------------------------------------------------------------------------------------------------
| ADS INITIALIZATION:
| runs:
| 		(__gh__webApp.ads.dfp.init();
|		__gh__webApp.utilities.lazyAds.init();)
|		OR
|		(ads.amazonHeader.init();)
|		AND
|		__gh__webApp.ads.nativo.init();
|------------------------------------------------------------------------------------------------------------------------------------
*/
__gh__webApp.ads.init = function(){
    var utilities 	= __gh__webApp.utilities,
		ads			= __gh__webApp.ads;

		if(!__gh__adsLoaded){
			/*var testKey='testing';
			if(__gh__webApp.utilities.GetURLParameter.init(testKey)=='amazonDirect'){*/
				ads.amazonHeader.init();
			/*}
			else {
				ads.dfp.init();	
				utilities.lazyAds.init();
			}*/
		 	
			
			ads.nativo.init(); 
			__gh__adsLoaded = true;
		}
};



/**
 * @namespace
 */
 __gh__webApp.ads.dfp = {
	 
	 
	 "init": function(){

		// Add variables to head section
		//declare and will make avaiable in header
		__gh__webApp.common.loadScript({
			"text"			: "var googletag=googletag||{},\r\ngptAdSlots=[],\r\ndfpIsLoaded = false,\r\n\/\/dfpNetworkId= __gh__coreData[\"3rdPartyData\"].ads.dfp.id,\r\n\/\/dfpNetworkId=\'11564835\',\r\ndfpFirstLevelAdUnit=__gh__coreData[\"3rdPartyData\"].ads.dfp.firstLevelAdUnit,\r\ndfpSecondLevelAdUnit=\'\',\r\n krux_catlist=\'\',defaultSlotsJSON=defaultSlotsJSON||\'\',__gh__articlePage_articleLoaded=false;"
		});
		
		var pgtype=null,
		blockingValue = (typeof(defslot_a) === "undefined") ? true : false;
		
		//Config
		pgtype=this.config(); 
		if(pgtype===false||blockingValue===true){return;} //exit DFP setup
		
		if(this.utilPiiCheck()){return;} //exit DFP setup
		
		//Library
		this.loadLibrary();
		
		if(__gh__webApp.utilities.GetURLParameter.init('disable')!='indexhb'){
			try{
				__gh__webApp.ads.indexHeader.init();
			}
			catch(e){
				debug.log('Error loading index Header. '+e)
				__gh__webApp.ads.indexHeader.loadFallback();
			}
		}
		else{
			__gh__webApp.ads.indexHeader.loadFallback();
		}
		
		//Load base targeting
	    this.loadBaseTargeting(pgtype);
		
	    //methods
		this.loadMethods();

	    //Load base slots
	    this.loadBaseSlots(pgtype);
	    
	    try{
		    if(__gh__coreData["3rdPartyData"].ads.dfp.topBarSponsor == 'true'){
				var container = '.ad-topbanner';
				this.triggerSlot(container);
			}
		} catch(e){
			debug.log('topBarSponsor error. '.e)
		}
	    
	    //slots rendered event listener
	    this.eventSlotsRendered();

	},
	/**
	 * Check URL for Personal Info. Kill ad requests if found.
	 */
	"utilPiiCheck": function() {
		try{ 
			
			var url=window.location.href;
			var p = __gh__webApp.common.getURLParts(url)
		    //debug.log("p.pathname = "+p.pathname)
		    
		    if(__gh__webApp.common.hasString(p.pathname,'@')||__gh__webApp.common.hasString(p.search,'@')){
			    debug.info('Pii in URL')
			    return true;
		    }
		    
		    if(__gh__webApp.common.hasString(p.pathname,'%40')||__gh__webApp.common.hasString(p.search,'%40')){
			     debug.info('Pii in URL')
			    return true;
		    }
			return false;

		}
		catch(e) {
			debug.info('Error checking URL for pii. '+e)
			return false;
		}
	},
	/**
	 * Format Key Values  with multiple values
	 */
	"utilFormatKeyValues": function(v) {
		//not sure this is actually needed
		try{ 
			
			if(__gh__webApp.common.hasString(v,',')){
						var newV='';
						mySplitResult = v.split(',');
						for(i = 0; i < mySplitResult.length; i++) {
							
							newV += '"'+mySplitResult[i]+'"';
							
							if(i<(mySplitResult.length-1)){
						    	newV += ',';
						    }

						}
						//newV += ']';
						
						return newV;
			}
			else{
				return v;
			}

		}
		catch(e) {
			debug.info('Error utilFormatKeyValues. '+e)
			return v;
		}
	},
	/**
	 * Set Configuration
	 */
	 "config": function() {
		try{
		 	//select the template and json feed needed

			var	tmpl 		   = null,
				currentPage 	   = __gh__webApp.currentPage,
				defaultSlots       = null,
				slotName		   = null,
				dfpNameSpace=__gh__webApp.ads.dfp
				pageData		   = __gh__coreData.pageData,
				templateType       = null
				shimClass		   = null,
				updateTrigger	   = true;
				__gh__coreData.globalVariables.ads = __gh__coreData.globalVariables.ads || {},
				__gh__coreData.globalVariables.ads.dfpTemplateType='';
				
			//NOTE Get function/mehtod build into currentPage Object to return (currentPage.Get)
			if (currentPage.isHome()){
				tmpl = "homepage";
				dfpSecondLevelAdUnit='/homepage';	
			}
			else if (currentPage.isVideo()){
				tmpl = "sectionVideo";
				debug.info("video")
				dfpSecondLevelAdUnit='/video';

			}
			else if (pageData.categoryID=='PHOTOGALLERY'){
				tmpl = "sectionPhoto";
				debug.info("photo gallery")
				dfpSecondLevelAdUnit='/photos';
			    
			}
			else if (currentPage.isSectionStandard()||currentPage.isSectionEnhanced()||currentPage.isSectionBasic()||currentPage.isImageDriven()||currentPage.is101Things()){
				tmpl = "sectionStandard";

			}
			else if (currentPage.isArticle()){
				tmpl = "article";

				//base 300x250
				slotName='baseMedRec';
				shimClass='ad-lazy';
				updateTrigger=true;
				dfpNameSpace.baseAdShim(slotName,shimClass,updateTrigger);
			}
			else if (typeof initAdData == 'function') { 
				initAdData(); 
				templateType=__gh__coreData.globalVariables.ads.dfpTemplateType;
				dfpSecondLevelAdUnit=__gh__coreData.globalVariables.ads.dfpSecondLevel;
				//krux_catlist = krux_catlist.replace(/(^\s*,)|(,\s*$)/g, ''); //strip trailing comma
				//krux_catlist=__gh__coreData.globalVariables.ads.keywords;
				
				var k = 'keyword';
				
				try{__gh__webApp.ads.dfp.buildKruxCatlist(k,__gh__coreData.globalVariables.ads.keywords,o='add')}catch(e){debug.info('Error building krux catlist using __gh__coreData.globalVariables.ads.keywords. '+e)}
				try{__gh__webApp.ads.dfp.buildKruxCatlist(k,__gh__coreData.pageData.profileName,o='add')}catch(e){debug.info('Error building krux catlist using profileName. '+e)}
				debug.info('templateType= '+templateType)
				tmpl = templateType;
				
				if(templateType!=='legacyHeader'&&templateType!=='search'&&dfpSecondLevelAdUnit!=='/auto'){
					slotName='baseLeaderboard';
					var appendID='content';
			    }
			    
			    this.utilCheckLayNewAds(dfpSecondLevelAdUnit)
    
			}
			else {
				debug.info('Error: No DFP template defined');
				tmpl = "verticalSlots";//Ryan attention. Changed to vertical from section?
				return tmpl;
			}
			
			try{
				if(tmpl == "sectionStandard") {
						//dfpSecondLevelAdUnit=pageData.buckets[0].adCode;
						//pageData.buckets[0].taxonomy
						var k = 'keyword';
						try{__gh__webApp.ads.dfp.buildKruxCatlist(k,pageData.buckets[0].taxonomy.toString(),o='replace')}catch(e){debug.info('Error building krux catlist using profile taxo. '+e)}
						//try{krux_catlist=pageData.buckets[0].taxonomy.toString().toLowerCase();}catch(e){debug.info('Error setting second level using profile taxo'+e)}
						
						try{__gh__webApp.ads.dfp.buildKruxCatlist(k,pageData.buckets[0].items.main[0].taxonomy.toString(),o='add')}catch(e){debug.info('Error building krux catlist using bucket item taxo. '+e)}
						
						try{__gh__webApp.ads.dfp.buildKruxCatlist(k,__gh__coreData.pageData.profileName,o='add')}catch(e){debug.info('Error building krux catlist using profileName. '+e)}
						//krux_catlist+=','+pageData.buckets[0].items.main[0].taxonomy.toString().toLowerCase();
						
						//krux_catlist+=','+pageData.buckets[0].title.toString().toLowerCase();
						//debug.log('section krux_catlist = '+krux_catlist)
						dfpSecondLevelAdUnit=dfpNameSpace.defineSecondLevel(krux_catlist);
						debug.log('section dfpSecondLevelAdUnit = '+dfpSecondLevelAdUnit)
				}
			}
			catch(e){
				debug.info('Error setting second section level ad unit'+e)
				dfpSecondLevelAdUnit='/news';
			}
			
			try{
				if(dfpSecondLevelAdUnit!== '' && dfpSecondLevelAdUnit.substring(0,1) !== '/') {dfpSecondLevelAdUnit='/'+dfpSecondLevelAdUnit;}
			}
			catch(e){
				debug.info('Error setting section level ad unit'+e)
			}
			
			debug.info('tmpl='+tmpl)
			
			if(tmpl == 'noads'){
				return false;
			}
			else {
				defaultSlotsJSON   = tmplDefinitionsJSON.template[tmpl].slotFeed; //Ryan attention.!!!!!!!!!!!!!!!!!!!!! WHERE is defaultSlotsJSON being defined?
				//debug.info('DFP defaultSlotsJSON= '+defaultSlotsJSON);
				return tmpl;
			}
			
			
	
			
		}
		catch(e){
				debug.info('Error loading DFP configuration'+e)
			}
	 },
	 
	/**
	 * Load the dfp library
	 */
	"loadLibrary": function(){
		try{
		//window.googletag = window.googletag || {};googletag.cmd=googletag.cmd||[],function(){var t=document.createElement("script");t.async=!0,t.type="text/javascript";var e="https:"==document.location.protocol;t.src=(e?"https:":"http:")+"//www.googletagservices.com/tag/js/gpt.js";var o=document.getElementsByTagName("script")[0];o.parentNode.insertBefore(t,o)}();
		
		// make sure we don't load gpt.js multiple times
            dfpIsLoaded = dfpIsLoaded || $('script[src*="googletagservices.com/tag/js/gpt.js"]').length;
            if (dfpIsLoaded) {
                return;
            }

            var loaded = $.Deferred();

            window.googletag = window.googletag || {};
            window.googletag.cmd = window.googletag.cmd || [];

            var gads = document.createElement('script');
            gads.async = true;
            gads.type = 'text/javascript';

            // Adblock blocks the load of Ad scripts... so we check for that
            gads.onerror = function () {
	            // dfpBlocked();
                debug.info('gaads onerror ads blocked!')
            };

            gads.onload = function() {
                // this will work with ghostery:
                if (!googletag._loadStarted_) {
                    googletag._adBlocked_ = true;
                    //execBlockEvents();
                }
                loaded.resolve();
            };

            var useSSL = 'https:' === document.location.protocol;
            gads.src = (useSSL ? 'https:' : 'http:') +
            '//www.googletagservices.com/tag/js/gpt.js';
            var node = document.getElementsByTagName('script')[0];
            node.parentNode.insertBefore(gads, node);

            // Adblock plus seems to hide blocked scripts... so we check for that
            if (gads.style.display === 'none') {
               debug.info('display none check: ads blocked!')
            }

            return loaded;
		
		
		}
		catch(e){
			debug.info('Error loading DFP library'+e)
		}
	}, 
	
	/**
	 * Load Targeting
	 */
	"loadBaseTargeting": function(pgtype) {
		try{
			
			var testKey='test';
			
			if(__gh__webApp.utilities.GetURLParameter.init('demo') != 'undefined') {
				__gh__webApp.ads.dfp.loadTestTargeting(testKey,__gh__webApp.utilities.GetURLParameter.init('demo'))
			}
				
				
			__gh__webApp.ads.dfp.loadTestTargeting(testKey,__gh__webApp.utilities.GetURLParameter.init(testKey))
			
		 
		var isUserLoggedIn = __gh__webApp.paywall.isUserLoggedIn(),
			isSubscriber = Krux.segments.indexOf('qjh2j7hcq'),
			thisObject = this;
			
		var kv_lookup = {};
		kv_lookup['~TaxonomyKeywords'] = {value: krux_catlist};
		kv_lookup['~Krux.user'] = {value: Krux.user};
		kv_lookup['~Unknown'] = {value: "Unknown"};	
		/*	
		//Check with Rich. Shoud Krux segment users be marked as subscribers or just logged in users?
		if(isSubscriber !== -1 || isUserLoggedIn !== ""){
			kv_lookup['~Unknown'] = {value: "Subscriber"};
		}
		else{
			kv_lookup['~Unknown'] = {value: "Unknown"};	
		}
		*/
		
		/*
		Below function string page URL paramaters and pass them to DFp as keyword
		Google Policy violation found in Fringe cases where PPI in URL (like email address)
		if(pgtype=='wrapper'){
		
			var url=window.location.href;
			var p = __gh__webApp.common.getURLParts(url)
		    debug.log("p.pathname = "+p.pathname)
		    var urlElements=p.pathname.split('/'),
		    pathKeywords='';
		    
		    $.each(urlElements, function(k, v) {
					 
					try{
					    //debug.info('key = '+k+'. value = '+v+'.') 
					    if(v!=""){ pathKeywords+=v+','; }
					}
					catch(e){
							debug.info('pathkeywords error. '+e)
					}
				 });
				pathKeywords = pathKeywords.slice(0, -1);//remove trailing comma
				kv_lookup['~TaxonomyKeywords'] = {value: krux_catlist+','+pathKeywords};
				//
		}
		*/
		
		if(isSubscriber !== -1 || (isUserLoggedIn !== ""&&isUserLoggedIn !== undefined)){
		kv_lookup['~Krux.segments'] = {value: "pntgd7sou,qjh2j7hcq"}; //add Real time segments: Subscriber segments qjh2j7hcq & pntgd7sou
		debug.info("isSubscriber = true");
		} else {
			kv_lookup['~Krux.segments'] = {value: ""}; 
			debug.info("isSubscriber = false");
		}
		
		//add unique id for page
		try{
			kv_lookup['~pageID'] = {value:  __gh__coreData.pageData.profileID};
		}
		catch(e){
			debug.info('pageID undefined  __gh__coreData.pageData.profileID '+e)
		}
		
		//pageData.profileID
		try{
			if(typeof(__gh__coreData.globalVariables.ads.keywords) !== 'undefined'){
				//kv_lookup['~TaxonomyKeywords'] = {value: __gh__coreData.globalVariables.ads.keywords};
				if(pgtype=='wrapper'){
					//kv_lookup['~TaxonomyKeywords'] = {value: __gh__coreData.globalVariables.ads.keywords.toString()};
					debug.info("kv_lookup['~TaxonomyKeywords'] = "+kv_lookup['~TaxonomyKeywords'])
				}
			}
		}
		catch(e){
			debug.info('Keyword lookup fail '+e)
		}
			
			
			 //Loop through keys Object @ defaultSlotsJSON.base.keyvalues;
			 googletag.cmd.push(function() {
				 $.each(defaultSlotsJSON.base.keyvalues, function(k, v) {
					 
					try{
					    if(v.charAt(0) == '~') { //check for valuse that need more stuff done
								//debug.info('something needs done'+v)
								//debug.info(v+' lookup = '+kv_lookup[v].value)
								v=kv_lookup[v].value;
						}
					}
					catch(e){
							debug.info('loadBaseTargeting kv_lookup error. '+e)
					}
					
					
					
					//v=thisObject.utilFormatKeyValues(v);
					/*if(__gh__webApp.common.hasString(v,',')){
						var newV='[';
						mySplitResult = v.split(',');
						for(i = 0; i < mySplitResult.length; i++) {
							
							newV += '"'+mySplitResult[i]+'"';
							
							if(i<(mySplitResult.length-1)){
						    	newV += ',';
						    }

						}
						newV += ']';
						
						v=newV;
					}*/
					
					//debug.log("values = "+v)
					
						
				 	googletag.pubads().setTargeting(k, v);
				 	
				 	var type="Page K/V pair";
					thisObject.utilDfpConsole(type,k,v);
				 	
				 });
			 });
		}
		catch(e) {
			debug.info('Error loading DFP base targeting')
		}
	},
	/**
	 * Load Methods
	 */
	"loadTestTargeting": function(k,v) { 
		try{
			if(v !== undefined) { googletag.cmd.push(function() { googletag.pubads().setTargeting(k, v);}); }
		 }
		 catch(e){
			 debug.info('Error loading test targeting'+e)
		 }
	},
	/**
	 * Load Methods
	 */
	"loadMethods": function() { 
		try{
			googletag.cmd.push(function() { 
			 	googletag.pubads().enableSingleRequest();
			 	googletag.pubads().disableInitialLoad();
			 	googletag.pubads().collapseEmptyDivs();
			 	googletag.enableServices();
			 });
		 }
		 catch(e){
			 debug.info('Error loading DFP methods'+e)
		 }
	}, 
	/**
	 * Load Base Slots
	 */
	"loadBaseSlots": function(pgtype) {
		try{
			
			debug.log('loadBaseSlots pgtype= '+pgtype)
			
			var thisObject=this,
				dfpNameSpace=__gh__webApp.ads.dfp,
				dfpNetworkId=__gh__coreData["3rdPartyData"].ads.dfp.id,//Ryan attention. do I need this globall?
				currentDimensions=null,
				currentId=null,
				dcount=0,
				currentMap=null,
				buildMap=null,
				currentView=null,
				jsonSlotStandard=null,
				jsonSlotsOutOfPage=null,
				interstitialCallback=false,
				interstitialCallbackID=null;
				
				if(pgtype=='article') {
			  		krux_catlist=dfpNameSpace.defineArticleKeywords();
			  		dfpSecondLevelAdUnit=dfpNameSpace.defineSecondLevel(krux_catlist);
			  		if(dfpSecondLevelAdUnit === false||dfpSecondLevelAdUnit === undefined) {dfpSecondLevelAdUnit='/news'} //for no taxonomy. Ryan attention does removed from
			  		debug.log('dfpSecondLevelAdUnit'+dfpSecondLevelAdUnit)
			  		//__gh__webApp.analytics.krux.refreshData()
		  		}
		  		
		  		var dfpAdUnitFull='/'+dfpNetworkId+'/'+dfpFirstLevelAdUnit+dfpSecondLevelAdUnit;
		  		
		  		var type="Ad Unit",
		  			k="";
					thisObject.utilDfpConsole(type,k,dfpAdUnitFull)

			googletag.cmd.push(function() {
				
				
			 jsonSlotStandard=defaultSlotsJSON.base.slots.standard;
			 jsonSlotsOutOfPage=defaultSlotsJSON.base.slots['rich media'];
			 
			 if(jsonSlotStandard !== undefined) {
				 
				 $.each(jsonSlotStandard, function(slotName, item) {
					/*if(thisObject.checkDiv(slotName) === false){
						Race condition with baseMedRec (or any div) not on page when this fires
						debug.log('div does not exsist'+slotName)
						//continue;
					}*/
					 
					currentId=defaultSlotsJSON.base.slots.standard[slotName].id,
					dcount=0,
					currentDimensions='',
					currentDimentionL=defaultSlotsJSON.base.slots.standard[slotName].dimensions.length,
					jsonDimensions=defaultSlotsJSON.base.slots.standard[slotName].dimensions,
					jsonKeyValues=defaultSlotsJSON.base.slots.standard[slotName].keyvalues;
	
					 //Define Standard Slot Dimensions
				    if(currentDimentionL > '1'){currentDimensions='[';}
				    $.each(jsonDimensions, function(d, ditem) {
						dcount+=1;
					  	currentDimensions += '['+ditem.size.w+','+ditem.size.h+']';
					  	if(currentDimentionL != dcount && currentDimentionL > 1){currentDimensions += ',';} 
				    });
				    if(currentDimentionL > '1'){currentDimensions+=']';}
				    
				    var type="Standard Slot",
				    k=slotName;
				    thisObject.utilDfpConsole(type,k,currentDimensions)
				     
				    //debug.info("currentDimensions= "+currentDimensions)
				     
				    //Define Slot
				    //gptAdSlots[currentId].slotname
					gptAdSlots[currentId]=googletag.defineSlot(dfpAdUnitFull, eval(currentDimensions), slotName).addService(googletag.pubads());
					
					currentMap=$('#'+slotName).attr('data-size-mapping');
					
					if(currentMap!=undefined) {
					    buildMap=googletag.sizeMapping();
					    
					    $.each(dfpMaps.map[currentMap], function(view, item) {
						    currentView=dfpMaps.map[currentMap][view];
						    
				    		//Build current slot sizeMapping
						    //debug.info("currentView.ad_sizes="+currentView.ad_sizes);
							buildMap.addSize(currentView.viewport, currentView.ad_sizes);
							
						var type="Mapping",
						k=slotName,
						v='Viewport = '+currentView.viewport+'. Size Mappings = '+currentView.ad_sizes;
						thisObject.utilDfpConsole(type,k,v)
							
						});
						//Add Mapping to current Slot
						gptAdSlots[currentId].defineSizeMapping(buildMap.build());

					}

				    //Define Standard Slot Key Values
				    $.each(jsonKeyValues, function(k, v) {
					    if(dfpNameSpace.utilKeyLength(k,v)){
	
						v=thisObject.keyValuePairShim(k,v,'pink',krux_catlist,'pink');
						//v=thisObject.utilFormatKeyValues(v);
						var type="Slot K/V pair";
						thisObject.utilDfpConsole(type,k,v)
						
						gptAdSlots[currentId].setTargeting(k, v); 
					  			
					  	}
				     });
				     
				    if(pgtype=='article') { gptAdSlots[currentId].setTargeting('keyword', krux_catlist); thisObject.utilDfpConsole(type='Slot K/V pair',k='keyword',krux_catlist) }

					headertag.display(slotName);
	
				  });
			  }
			  
			  if(jsonSlotsOutOfPage !== undefined) {
				  $.each(jsonSlotsOutOfPage, function(slotName, item) {
					currentId=jsonSlotsOutOfPage[slotName].id,
					dcount=0;

				    
				    var type="OutofPage Slot",
				    k=slotName,
				    currentDimensions='1,1';
				    thisObject.utilDfpConsole(type,k,currentDimensions)
	
				    //Define current Out of page slot
				    	gptAdSlots[currentId]=googletag.defineOutOfPageSlot(dfpAdUnitFull, slotName).addService(googletag.pubads());
				    
				    try{
					    //Define Rich Media Key Values
				        $.each(jsonSlotsOutOfPage[slotName].keyvalues, function(k, v) {
					        if(dfpNameSpace.utilKeyLength(k,v)){
						        
						        var type="Slot K/V pair";
								thisObject.utilDfpConsole(type,k,v)
								v=thisObject.keyValuePairShim(k,v,'pink',krux_catlist,'pink');
						  		gptAdSlots[currentId].setTargeting(k, v);
						  	}
					     });
					     
					     if(pgtype=='article') { gptAdSlots[currentId].setTargeting('keyword', krux_catlist); thisObject.utilDfpConsole(type='Slot K/V pair',k='keyword',krux_catlist)}
				     }
				     catch(e){
					     debug.info("Error Defining Rich Media Key Values"+e)
				     }

				     
				    var appendID='footer-main';
				    if(slotName=='slidingBillboard') {
					    appendID='header-content';
					    try{dfpNameSpace.collapseSlot(currentId,slotName);}catch(e){debug.info("Collapse fail. "+slotName);} //collaspe div
					}

				    dfpNameSpace.createDiv(slotName,appendID,sizeMapping=''); 
				    
					
					//Interstital checks for callback / bind to Lightbox events
					if(typeof(__gh__coreData["3rdPartyData"].paywall.pressplus.ids) !== 'undefined'&& pgtype == 'article' && slotName=='interstitial'){
						interstitialCallback='pressplus';
						interstitialCallbackID=gptAdSlots[jsonSlotsOutOfPage['interstitial'].id];
				    }
				    else if(__gh__coreData.pageData.isExtLogin === true&& pgtype == 'article' && slotName=='interstitial'){
						try{
						    debug.info('Interstital not shown due to MPP lightbox event. ')
	
						}
						catch(e){
							debug.info('Error interstital bound to pressPlusLightboxNotOpen(). '+e)
						}
				    }
				    else {
					    headertag.display(slotName); //Display slot 
					    //debug.info("RICH Media");
					    if(slotName=='interstitial'){ debug.info("[Interstital] NO PRESS+ lightbox bind event");}
				    }
	
				  });
			  }
			  
			  if(interstitialCallback=='pressplus'){
				//interstital not refreshed until pressplusLightboxnotopen() callback made 
				headertag.pubads().refresh([gptAdSlots[0],gptAdSlots[1]]); //fetch all base slots, minus interstitial (gptAdSlots[2] on articles)
				thisObject.callBackInterstitial(interstitialCallbackID);
			  }
			  else{
				headertag.pubads().refresh(); //fetch all base slots  
			  }
			  
			  googletag.pubads().clearTargeting('amznslots'); // clear custom Amazon match targeting value by key
			  
			  return true;
			});  

		}
		catch(e){
			debug.info('Error loading base slots'+e)
			return false;
		}
	},
	
	/**
	 * Generate Slot name for lazy loading ads
	 */
	"generateSlotName": function() { 
		
		try{
			var id = gptAdSlots.length+1;
			debug.info("new slot name lazySlot"+id)
			return 'lazyAd-'+id;
		 }
		 catch(e){
			 debug.info('Error generating slot name')
		 }
	}, 
	
	/**
	 * Create New DFP Slots
	 */
	"createLazySlot": function(container) { 
		try{
			var container = (typeof container !== 'undefined') ?  container : '.ad-lazy';
			var slotName=__gh__webApp.ads.dfp.generateSlotName(),
			$myAd=$(container).first();
			debug.log('container= '+container)
			$myAd.attr('id', slotName);
			__gh__webApp.ads.dfp.defineSlot(slotName);
			$myAd.removeClass( container.replace('.','') ); // remove ad-lazy class so the ad does not get processed again

		 }
		 catch(e){
			 debug.info('Error creating slot'+e)
		 }
	}, 
	/**
	 * Check if Div with DFP ID exsits to target.
	 */
	"checkDiv": function(slotName) { 
		try{
				var myAdElem = document.getElementById(slotName);
					
				if (myAdElem === null) {
						debug.warn("Warning: Element with div ID= "+slotName+" does not exsist. Ad slot not being called.")
						
						return false;
				}
				else{
					return true;
				}
		 }
		 catch(e){
			 debug.info('Error checking for div ID for slot '+slotName+'. '+e);
			 return false;
		 }
	}, 
	/**
	 * Create Div for DFP Slots
	 */
	"createDiv": function(slotName,appendID,sizeMapping) { 
		try{
				var myAdElem = document.getElementById(slotName),
					myElem = document.getElementById(appendID);
					
				if (myAdElem === null) {
					if (myElem === null) {
						debug.warn("Warning: Element with ID= "+appendID+" does not exsist. Adding it.")
						
						var featuredDiv = document.createElement('div'),
						el2=document.getElementById("content");
						
						featuredDiv.id = appendID; // Id must be the same as slotName
						el2.insertBefore(featuredDiv,el2.firstChild); //add to dom
					}
					
					//Create div on the fly for ad unit
					var slotDiv=slotDiv = document.createElement('div'),
					el=document.getElementById(appendID);
					
					   // Create a div for the slot
					   slotDiv.id = slotName; // Id must be the same as slotName
					   if(sizeMapping!=''){
						   var att = document.createAttribute("data-size-mapping");       // Create a "data-size-mapping" attribute
							att.value = sizeMapping;                           // Set the value of the data-size-mapping attribute
							slotDiv.setAttributeNode(att);
					   }
					   el.insertBefore(slotDiv,el.firstChild); //add to dom
					   $('#'+slotName).addClass('ad text-center'); 
					return true;
				}
				else{
					debug.warn("Warning: DFP div with ID= "+slotName+" already exsist. Not adding it.")
					return false;
				}
		 }
		 catch(e){
			 debug.info('Error creating div for slot '+slotName+'. '+e);
			 return false;
		 }
	}, 
	
	
	/**
	 * Define Slots
	 */
	"defineSlot": function(slotName) {
		
		try{
			var thisObject=this;
			googletag.cmd.push(function() {
				//debug.info("TRYING to Define SLOT")
				var dfpNameSpace=__gh__webApp.ads.dfp,
				dfpNetworkId=__gh__coreData["3rdPartyData"].ads.dfp.id,
				$adUnit =$('#'+slotName);
				dimensions=$adUnit.attr('data-dimensions'),
				targeting=$adUnit.attr('data-targeting'),
				currentMap=$adUnit.attr('data-size-mapping'),
				dfpID=gptAdSlots.length,
				gptAdSlotsLazy=[],
				dfpAdUnitFull='/'+dfpNetworkId+'/'+dfpFirstLevelAdUnit+dfpSecondLevelAdUnit;
				
				
				var type="Standard Slot",
				    k=slotName;
				    try{thisObject.utilDfpConsole(type,k,dimensions)}catch(e){debug.info('Fail outputing log'+e)}

				gptAdSlots[dfpID]=googletag.defineSlot(dfpAdUnitFull, eval(dimensions), slotName).addService(googletag.pubads());
				
				
				currentMap=$('#'+slotName).attr('data-size-mapping');//Ryan attention. Duplicated above
				
				if(currentMap!=undefined) {
				    buildMap=googletag.sizeMapping();
				    
				    $.each(dfpMaps.map[currentMap], function(view, item) {
					    currentView=dfpMaps.map[currentMap][view];
			    		//Build current slot sizeMapping
					    //debug.info("currentView.ad_sizes="+currentView.ad_sizes);
					    var type="Mapping",
						k=slotName,
						v='Viewport = '+currentView.viewport+'. Size Mappings = '+currentView.ad_sizes;
						thisObject.utilDfpConsole(type,k,v)
					    
						buildMap.addSize(currentView.viewport, currentView.ad_sizes);
	
					});
					//Add Mapping to current Slot
					gptAdSlots[dfpID].defineSizeMapping(buildMap.build());

				}
				
				// Sets custom targeting for just THIS ad unit if it has been specified
				try{
                    var targeting = $adUnit.data('gh-lazy-ad-bucket-targeting');
                    //  targetingObj= $.parseJSON(targeting);
                    //debug.info('targeting'+targeting)
                    
                    
                    if (targeting) {
                        $.each(targeting, function (k, v) {
	                        var keyValueLength= v.length;
						    //debug.info('key '+k+' length of value '+v+' is '+keyValueLength)
						    
						    //__gh__webApp.ads.dfp.buildKruxCatlist(k,v);
						    
						    if(dfpNameSpace.utilKeyLength(k,v)){
							    var type="Slot K/V pair";
								thisObject.utilDfpConsole(type,k,v)
								v=thisObject.keyValuePairShim(k,v,'pink',krux_catlist,'pink');
								gptAdSlots[dfpID].setTargeting(k, v);	
					  		}
						    
                        });
                    }
                    
				}
				catch(e){
					debug.info('target fail'+e)
				}
				
				try{
					
                    if (__gh__coreData.globalVariables.ads.dfpTemplateType='native') {
                        //$.each(targeting, function (k, v) {
	                        
	                        k='articleKey';
	                        //v=articleKey;
	                        v=__gh__coreData.globalVariables.ads.articleKey;
	                        //debug.log('articleKey='+articleKey)
						    
							    var type="Slot K/V pair";
								thisObject.utilDfpConsole(type,k,v)
								gptAdSlots[dfpID].setTargeting(k, v);	
                    }
                 }
                 catch(e){
					debug.info('Native target fail. '+e)
				}
				
				__gh__webApp.ads.dfp.renderSlot(dfpID,slotName);
				
				//headertag.display(slotName);
				//headertag.pubads().refresh([gptAdSlotsLazy[currentId]]);
					//////ADDDD TARGETING>>>>>>////////
				//debug.info("END TRYING to Define SLOT")	
				return;
			});	
		}
		catch(e){
			debug.info('Error defining DFP slot'+e);
		}

	},
	/**
	 * Define section Leve ad units base on keywords
	 * Looks though krux_catlist and using first taxonomy match found for second level ad unit
	 */
	"defineSecondLevel": function(krux_catlist) {
		try{
			var dfpSecondLevelMap = {
				"taxonomy": {
					"sports" : "sports",
					"preps"	 : "sports",
					"high school"	 : "sports",
					"dcpreps"	 : "sports",
					"motor racing network"	 : "sports",
					"news" : "news",
					"entertainment": "entertainment",
					"tempo": "entertainment",
					"go": "entertainment",
					"books": "entertainment",
					"movies": "entertainment",
					"weather"	:	"weather",
					"lifestyle" : "lifestyle",
					"opinion"	: "opinion",
					"editorials"	: "opinion",
					"letters"	: "opinion",
					"obituaries": "obituaries",
					"frontpage": "homepage", //__gh__coreData.pageData.pageType
					"sectionVideo": "video",
					"PHOTOGALLERY": "photos", //__gh__coreData.pageData.pageType = section && __gh__coreData.pageData.categoryID ==PHOTOGALLERY
					"jobs": "jobs",//__gh__coreData.pageData.categoryID = blank right now
					"classifieds": "classifieds",//__gh__coreData.pageData.categoryID = blank right now
					"realestate": "homefinders",
					"real estate": "homefinders",
					"hdca": "homefinders",
					"cape homes": "homefinders",
					"real estate cover": "homefinders",
					"cars": "auto", //__gh__coreData.pageData.categoryID
					"automotive": "auto",
					"business": "business",
					"local business": "business",
					"business news": "business",
					"52": "business",
				}
			}
			
			var dfpSecondLevelAdUnit;
			
			var taxo_split = krux_catlist.split(','),
			dfpTaxoMap=dfpSecondLevelMap.taxonomy;
			
			
			$.each(taxo_split, function(k, v) {
			    //debug.log('key='+k+'; value='+v+';')
			    //debug.log('index check '+dfpTaxoMap[v])
			    
			    
			    if(dfpTaxoMap[v] !== undefined){
				    dfpSecondLevelAdUnit='/'+dfpTaxoMap[v];
				    //debug.log('inArray dfpSecondLevelAdUnit='+dfpSecondLevelAdUnit)
				    return false; //break each loop
			    }
			     
			}); 
			
			if(dfpSecondLevelAdUnit==''||dfpSecondLevelAdUnit===undefined) {dfpSecondLevelAdUnit='/news'; debug.info('default to /news')}
			return dfpSecondLevelAdUnit;
		}
		catch(e){
			debug.error('Defining DFP Second Level Ad unit failed. '+e);
			return false;
		}
	},

	/**
	 * Render Slots
	 */
	"renderSlot": function(n,slotName) {
		try{
			// Define the slot itself, call display() to 
			// register the div and refresh() to fetch ad.
			//debug.info("trying to render slot n="+n+" slotname="+slotName)
		   googletag.cmd.push(function() {
		
			     // Display has to be called before
			     // refresh and after the slot div is in the page.
				try {
					headertag.display(slotName);
					headertag.pubads().refresh([gptAdSlots[n]]);
				}
				catch (e) {
					// statements to handle any exceptions
					debug.info(slotName+' dynamic slot failed'); // pass exception object to error handler
				}

		   });
		}
		catch(e){
			debug.info('Error rendering slot'+e);
		}
		
	},

	/**
	 * Collapse Slots
	 */
	"collapseSlot": function(currentId,slotName) {
		try{
			// Collapse Slots
			//setCollapseEmptyDiv(collapse, opt_collapseBeforeAdFetch)
			// The below will cause the div for this slot to be collapsed
			// when the page is loaded, before the ads are requested
		   googletag.cmd.push(function() {
		
			     // Collapse
				try {
					gptAdSlots[currentId].setCollapseEmptyDiv(true, true);
					//debug.info(slotName+' collapse slot. For currentId='+currentId); // pass exception object to error handler
				}
				catch (e) {
					// statements to handle any exceptions
					debug.info(slotName+' collapse slot failed'); // pass exception object to error handler
				}

		   });
		}
		catch(e){
			debug.info('Error collaping slot'+e);
		}
		
	},
	/**
	 * Base Ad Section Shim
	 */
	"baseAdShim": function(slotName,shimClass,updateTrigger) {
		try{ 
			//debug.log('shim slotName'+slotName)
			//shimClass= ad-lazy
			var $myAd=$( '.'+shimClass).first();
				$myAd.attr('id', slotName);
			//debug.log('$myAd'+$myAd)	
				if(slotName === 'baseLeaderboard'||slotName === 'baseLeaderBillboard'){ 
					$myAd.attr('data-size-mapping', slotName); 
					$myAd.parent( ".inner" ).removeClass( "inner");
				}
				//RYAN look at why this isn't working $myAd.removeClass( shimClass )
				
				if(updateTrigger===true) {
					var $loadAd = $("[data-gh-lazy-ad-loaded=false]").first();
					$loadAd.attr("data-gh-lazy-ad-loaded",true);
				}
				$myAd.removeClass( shimClass ); // remove ad-lazy class so the ad does not get processed again
				//$myAd.removeClass( "ad-lazy" ); // remove ad-lazy class so the ad does not get processed again

				return;
		}
		catch(e) {
			debug.info('Error building section shim '+e)
			return;
		}
	},
	/**
	 * Key Value Pair  Shim
	 */
	"keyValuePairShim": function(k,v,needle,haystack,vUpdate) {
		try{
			//debug.log('v=== '+v)
			if(k==='sov'){
				
				if(haystack.split(',').indexOf(needle) > -1 ) {
				   // found
				   //debug.log('found');
				   v=vUpdate;
				}    
				//debug.log('v=== '+v)
			    //debug.log('krux catlist=== '+krux_catlist)
		    }
				return v;
		}
		catch(e) {
			debug.info('Error building Key Value Pair shim '+e)
			return;
		}
	},
	/**
	 * Define Article Keywords to pass to ad slots
	 */
	"defineArticleKeywords": function() {
		try {
			//Ryan attention. Chris combined these in one.
			//add article taxomomies 
			//Grab Article Data feed URL to get Taxonomy
			var articleJsonURL = __gh__coreData.pageData.buckets[0].feedURL //Grab informaiton for the first article
			//Ryan attention. Instead of grapping this URL and fetching feed URL agian. Can this data be grabbed from __gh__coreData.pageData.buckets[0].main.items?
			//1 needs to be a variable that tells me what the current aritcle we are on is
			var dfpNameSpace=__gh__webApp.ads.dfp,
				articleJson= __gh__webApp.utilities.fetch.json.get({"url": articleJsonURL}),
				articleKeywords = articleJson.main[0].keywords,
				articleTaxonomy = articleJson.main[0].taxonomy,
				keywordList='';
			
			if(articleKeywords !== undefined) {
				$.each(articleKeywords, function(k, v) {
					if(dfpNameSpace.utilKeyLength(k,v)){ keywordList+=v.trim()+','; }	
				});
			}
			
			if(articleTaxonomy !== undefined) {
				$.each(articleTaxonomy, function(k, v) {
					//debug.info("============================== value= "+v)
					if(dfpNameSpace.utilKeyLength(k,v)) { keywordList+=v.trim()+','; }
				});
			}
			
			keywordList = keywordList.slice(0, -1);//remove trailing comma
			keywordList=keywordList.toLowerCase();
			
			debug.info('ARticle keyword list_____----->= '+keywordList);
			return keywordList;
			}
		catch(e){
			debug.info('Article keyword fail. '+e)
		}
	},
	
	/**
	 * Key Lenth Utility Checker
	 */
	"utilKeyLength": function(k,v) {
		try{ 
			
			//
			var keyValueLength;
			if(k==='keyword'||k==='creative-format') {
				var vSplit=v.split(',')
				for(var i = 0; i < vSplit.length; i++) {
				   // Trim the excess whitespace.
				   //vSplit[i] = vSplit[i].replace(/^\s*/, "").replace(/\s*$/, "");
				   // Add additional code here, such as:
				   keyValueLength= vSplit[i].length;
				   //debug.log('vSplit[i]='+vSplit[i])
				    if(keyValueLength <= 40){
					    //donothing to keep looping through
					}
				  	else {
					  	debug.warn('Keyword Warning: Key='+k+'. Value length > 40 chars @ '+keyValueLength+' not used. Value='+v);
					  	return false;
				  	}
				}
				//if we made it though the loop, return true as keyword lengths are fine
				return true;
			}			
			else {
					keyValueLength= v.length;
				    if(keyValueLength <= 40){ return true;}
				  	else {
					  	debug.warn('Warning: Key='+k+'. Value length > 40 chars @ '+keyValueLength+' not used. Value='+v);
					  	return false;
				  	}
				
			}
			
			

		}
		catch(e) {
			debug.info('Error checking key value length. '+e)
			return;
		}
	},
	/**
	 * topBarSponsor
	 */
	"triggerSlot": function(container) { 
		try{
			
			__gh__webApp.ads.dfp.createLazySlot(container);	
		 }
		 catch(e){
			 debug.info('Error on triggerSlot(). '+e)
		 }
	},
	/**
	 * Output DFP Debug Utility
	 */
	"utilDfpConsole": function(type,k,v) { 
		try{
			var debugKey='dfpconsole';
			if(__gh__webApp.utilities.GetURLParameter.init(debugKey)){
				if(type=='Page K/V pair'||type=='Slot K/V pair'){
					debug.info('DFP--> '+type+": key="+k+". value="+v)
				}else if(type=='Standard Slot'||type=='OutofPage Slot'){
					debug.info('DFP--------------> '+type+": slot="+k+". dimensions="+v+"<--------------")
				}else{
					debug.info('DFP--> '+type+": value="+v)
				}
					
			}	
		 }
		 catch(e){
			 debug.info('Error Outputing DFP Debug data. '+e)
		 }
	},
	/**
	 * Utility to manage laying down new ads based on page and div elements by id or class
	 */
	"utilCheckLayNewAds": function(dfpSecondLevel) { 
		try{

			/*if(dfpSecondLevel=='/jobs'){
				this.utilLayNewAds(innerContainer='#content',rightContainer='.ad-container', adMarginTop=450)
			}*/
			
			if(dfpSecondLevel=='/classifieds'){
				this.utilLayNewAds(innerContainer='.col-md-8',rightContainer='#dfpAds', adMarginTop=600)
			}
			
			if(dfpSecondLevel=='/auto'){
				this.utilLayNewAds(innerContainer='#content',rightContainer='.ad-container', adMarginTop=600)
			}

		 }
		 catch(e){
			 debug.info('Error Checking to Lay down New Ads. '+e)
		 }
	},
	/**
	 * Utility to lay down new ad positioin in a right rail if space if available
	 */
	"utilLayNewAds": function(innerContainer,rightContainer,adMarginTop) { 
		try{
			var w = $(window).width();
			if( w > 990 ){
				function setNewAds(adMarginTop){	
					
					$('.newRailAds').remove(); // remove all ads on the page
					
					var innerHeight		= $(innerContainer).height(), // grab height on left column
						rightbarHeight	= $(rightContainer).height(),  // grab height of right column
						newAdSpace		= innerHeight - rightbarHeight,  // amount of real estate in right rail
						adHeight		= 250, //height of ad
						adSpace			= adHeight+adMarginTop, // amount of space one ad will take up.  250px + 600px padding
						numAds 			= Math.floor(newAdSpace/adSpace);  // number of ads that will fit in the extra space
						
						debug.log("==========================");
						debug.log("==========================");
						
						debug.log('innerHeight: '+innerHeight);	
						debug.log('rightbarHeight: '+rightbarHeight);	
						debug.log('adSpace: '+adSpace);
						debug.log('newAdSpace: '+newAdSpace);

						
						if (numAds > 0){
							
							debug.log("Number of ads we can add: "+numAds);
							
							for (i = 0; i < numAds; i++) { 
								var templ = '<div class="newRailAds" style="margin-top: '+adMarginTop+'px;" data-gh-lazy-ad-loaded="false"><div class="ad ad-lazy" data-gh-lazy-ad-bucket-targeting=\'{"ad-type":"standard","slot":"View Plus Med Rec","sov":"Standalone"}\'  data-dimensions="[300,250]"></div></div>';
								$(rightContainer).append(templ);
							}
							
						} else {
							debug.log('No extra ads can be drawn.');
						}
						
						debug.log("==========================");
						debug.log("==========================");
				}	
				
				
				/*
					 * Wait for all elements on the page to render
				 * 
				 *
				 *
				 */
				setTimeout(function(){ 
					setNewAds(adMarginTop);
				}, 2000);	


				/*
				* Detect a change in the URL.
				*  For example, if a user Filters content
				*  recalculate the white space in the right rail 
				*
				*
				*/
				var oldLocation = location.href;
				setInterval(function() {
					if(location.href != oldLocation) {
						// do your action
						setNewAds(adMarginTop);
						debug.log("URL has changed")
						oldLocation = location.href
					}
				}, 1000); // check every second
				
			} // end window.width
		 }
		 catch(e){
			 debug.info('Error Laying New Ads. '+e)
		 }
	}, 
	/**
	 * Build Map Targeting
	 */
	"buildMapping": function(currentMap) {
		try{ 
			googletag.cmd.push(function() {
				var dpfMapping=googletag.sizeMapping(),
					//mapURL = "http://redesign.gatehousemedia.com/master/assets/json/dfp/dfpMaps.json",
					//dfpMaps   = __gh__webApp.utilities.fetch.json.get({"url": mapURL}),
					currentView=null;

				$.each(dfpMaps.map[currentMap], function(view, item) {
				    currentView=dfpMaps.map[currentMap][view];
					//Build current slot sizeMapping
				    debug.info("currentView.ad_sizes="+currentView.ad_sizes);
					dpfMapping.addSize(currentView.viewport, currentView.ad_sizes);
				}); 
				
				return dpfMapping;
			});
							/*
				try{
				    if(currentMap!=undefined) {
						buildMap= __gh__webApp.ads.dfp.buildMapping(currentMap);
						debug.info(buildMap)
						//Add Mapping to current Slot
						gptAdSlots[currentId].defineSizeMapping(buildMap.build());
					}
				}
				catch(e){
					debug.info('Build map failed')
				}
				*/
			
		}
		catch(e) {
			debug.info('Error building map'+e)
			return;
		}
	},
	/**
	 * Build krux_catlist
	 */
	"buildKruxCatlist": function(k,v,o) {
		try{ 
			
			if(k == 'article keywords'){ //add keywords to list for krux if it does not already exsist
				v=JSON.stringify(v);
				
				v=v.replace('[','');
				v=v.replace(']','');
				v=v.replace('"','');
				v=v.replace(/\"/g, '')
				k == 'keyword'
			}
			//var vSplit=v.split(',')
			//if(k == 'keyword'&&krux_catlist.indexOf(v.toLowerCase()) === -1){ //add keywords to list for krux if it does not already exsist
			
			
				
				   if(k.substring(0,1) == ','){
					   k = k.replace(/^,/, '');
				   }
				   
				   if(o == 'add'){
					   
					   if(krux_catlist.length === 0) {
					   	   krux_catlist = v.toLowerCase();
					   }
					   else{
						   krux_catlist += ','+v.toLowerCase();
						   
						   var uniqueList=krux_catlist.split(',').filter(function(item,i,allItems){
							    return i==allItems.indexOf(item);
							}).join(',');
							
							//debug.log('uniqueList='+uniqueList)
							krux_catlist=uniqueList; 
					   }
				   
				   }
				   else {
					 	krux_catlist = v.toLowerCase();  
				   }
				   
				   krux_catlist=krux_catlist.replace(/(^\s*,)|(,\s*$)/g, ''); //strip trailing comma


			debug.log('krux_catlist='+krux_catlist)
			return true;
			
		}
		catch(e) {
			debug.info('Error building buildKruxCatlist'+e)
			return;
		}
	},
	
	/**
	 * Slots Rendered 
	 * fires off after each slot is rendered. Specific slot need chosen if needed
	 */
	"eventSlotsRendered": function() {
		try {
			googletag.cmd.push(function() {
				googletag.pubads().addEventListener('slotRenderEnded', function(event) {
				/*
					Hacky way of doing this. It could break. need to pass the slot...
				  debug.log('DFP SLOTS RENDERED')
				  //debug.log('event.slot= '+event.slot)
				  try{
					   debug.log('count= '+count)
				  }
				  catch(e){
					  	debug.error('count error= '+e)
				  }
				 
				 // gptAdSlots[currentId]
				  //Add Listener for Sliding Billboard Slot
				  //if (event.slot === gptAdSlots[1000]&&ad_data_feed[abd_pagetype].dfp_sliding_billboard === true) {
				 if(gptAdSlots[count].l.m == 'slidingBillboard'){
				   debug.log('gptAdslots'+gptAdSlots[count].l.m)
				    
				  }
				  count+=1;
				  
				*/  
				});
				return true;
			});
		}
		catch (e) {
		   //handle any exceptions
		   debug.info('Error adding slotRenderEnded listener. '+e)
		   return false;
		}

	},
	
	/**
	 * Callback function for interstitial ad unit for Press+
	 */
	"callBackInterstitial": function(slotID) { 
		
		try{
			try{
				    jQuery(window).bind("pressPlusLightboxNotOpen", function (e) {
					 // if(__gh__articlePage_fullArticleCount === 0) {
						  headertag.display('interstitial'); //Display slot on press+ article pages if paywall lightbox will not open
					      debug.info("[Interstital DFP Slot] DISPLAY: Press+ site article page. Article open count"+__gh__articlePage_fullArticleCount);
					      headertag.pubads().refresh([slotID]); //refresh interstitial slot
				      //}

					});
				}
			catch(e){
				debug.info('Error interstital bound to pressPlusLightboxNotOpen(). '+e)
			}
		 }
		 catch(e){
			 debug.info('Error in callBackInterstitial(). '+e)
		 }
	},
	 
 };
 
 
 
 
 
 
/*
|--------------------------------------------------------------------------
| Ads: Nativo
|--------------------------------------------------------------------------
*/
/**
 * @namespace
 */
__gh__webApp.ads.nativo = {
	
	/**
	 * Initialize
	 */
	"init": function(){
		__gh__webApp.common.loadScript({
			"src": "//s.ntv.io/serve/load.js"
		});
	},
	
	/**
	 * Article DFP Passback tag
	 */
	"dfpPassback": function(){
		__gh__webApp.common.loadScript({
			"src": "//s.ntv.io/serve/load.js"
		});
	}

};



/*

|--------------------------------------------------------------------------
| Ads: Index Header Bidding 
|--------------------------------------------------------------------------
*/
/**
 * @namespace --  
 */
__gh__webApp.ads.indexHeader = {
	
	/**
	 * Initialize
	 */
	"init": function(){
		this.config();
		this.loadLibrary();
		this.loadFallback();
	},
	
	/**
	 * Add a configuration object
	try{ 
		if(typeof appNexusIds.default[dfpFirstLevelAdUnit] === 'undefined'){
			debug.log('AppNexus ID undefined') 
			window.headertag = window.headertag || {};
		    window.headertagconfig = {
		        "siteId": 184420,
		        "timeout": 700,
		        "disableInitialLoad": true,
		        "enableSingleRequest": true,
		        "partners": {
		            "INDX": {
		                "targetingType": "slot",
		                "timeout": 600
		            }
		        }
		    };
		}
		else {
			var pID = appNexusIds.default[dfpFirstLevelAdUnit].pid;
	
			window.headertag = window.headertag || {};
		    window.headertagconfig = {
		        "siteId": 184420,
		        "timeout": 700,
		        "disableInitialLoad": true,
		        "enableSingleRequest": true,
		        "partners": {
					"APNX": {
		             "disabled": false,
		             "targetingType": "slot",
		             "timeout": 600,
		             "adUnits": [],
		             "adUnitTypes":{
		                "Base Med Rec":[
		                    {
		                        "platform":"mobile",
		                        "pagetype":0,
		                        "sizes":[[300,250]],
		                        "bids":[{
		                            "bidder":"appnexus",
		                            "params":{"placementId": pID}
		                        }]
		                    },{
		                        "platform":"desktop",
		                        "pagetype":0,
		                        "sizes":[[300,250]],
		                        "bids":[{
		                            "bidder":"appnexus",
		                            "params":{"placementId": pID}
		                        }]
		                    }
		                   
		                ],
		                "Base Leaderboard":[
		                	{
		                        "platform":"desktop",
		                        "pagetype":0,
		                        "sizes":[[728,90],[970,90],[970,250]],
		                        "bids":[{
		                            "bidder":"appnexus",
		                            "params":{"placementId": pID}
		                        }]
							},{
		                        "platform":"mobile",
		                        "pagetype":0,
		                        "sizes":[[320,50],[300,250]],
		                        "bids":[{
		                            "bidder":"appnexus",
		                            "params":{"placementId": pID}
		                        }]
							}
						]
					  },
					  "roundingBuckets": {
			                "max": 20.00,
			                "type": 1,
			                "buckets": [{
			                    "range": [0, 20],
			                    "granularity": 0.05
			                }]
			            }
		                
		            },
		            "INDX": {
		                "targetingType": "slot",
		                "timeout": 600
		            }
		        }
		    };
		 }
    }
    catch(e){
		debug.log("Error configuring Index Header Wrapper"+e)
	}
    //CONFIGURING WRAPPER PARTNERS
    //https://wiki.headertag.com/2016/08/22/configuring-wrapper-partners/
    window.headertag = window.headertag || {};
    window.headertagconfig = {
        "siteId": 184420,
        "timeout": 700,
        "disableInitialLoad": true,
        "enableSingleRequest": true,
        "partners": {
            "INDX": {
                "targetingType": "slot",
                "timeout": 600
            }
        }
    };
	 */
	"config": function(){
		debug.log('indexHeader config load.')
		
		__gh__webApp.common.loadScript({
			"text"			: "try{ \r\n\t\tif(typeof appNexusIds.default[dfpFirstLevelAdUnit] === \'undefined\'){\r\n\t\t\tdebug.log(\'AppNexus ID undefined\') \r\n\t\t\twindow.headertag = window.headertag || {};\r\n\t\t    window.headertagconfig = {\r\n\t\t        \"siteId\": 184420,\r\n\t\t        \"timeout\": 700,\r\n\t\t        \"disableInitialLoad\": true,\r\n\t\t        \"enableSingleRequest\": true,\r\n\t\t        \"partners\": {\r\n\t\t            \"INDX\": {\r\n\t\t                \"targetingType\": \"slot\",\r\n\t\t                \"timeout\": 600\r\n\t\t            }\r\n\t\t        }\r\n\t\t    };\r\n\t\t}\r\n\t\telse {\r\n\t\t\tvar pID = appNexusIds.default[dfpFirstLevelAdUnit].pid;\r\n\t\r\n\t\t\twindow.headertag = window.headertag || {};\r\n\t\t    window.headertagconfig = {\r\n\t\t        \"siteId\": 184420,\r\n\t\t        \"timeout\": 700,\r\n\t\t        \"disableInitialLoad\": true,\r\n\t\t        \"enableSingleRequest\": true,\r\n\t\t        \"partners\": {\r\n\t\t\t\t\t\"APNX\": {\r\n\t\t             \"disabled\": false,\r\n\t\t             \"targetingType\": \"slot\",\r\n\t\t             \"timeout\": 600,\r\n\t\t             \"adUnits\": [],\r\n\t\t             \"adUnitTypes\":{\r\n\t\t                \"Base Med Rec\":[\r\n\t\t                    {\r\n\t\t                        \"platform\":\"mobile\",\r\n\t\t                        \"pagetype\":0,\r\n\t\t                        \"sizes\":[[300,250]],\r\n\t\t                        \"bids\":[{\r\n\t\t                            \"bidder\":\"appnexus\",\r\n\t\t                            \"params\":{\"placementId\": pID}\r\n\t\t                        }]\r\n\t\t                    },{\r\n\t\t                        \"platform\":\"desktop\",\r\n\t\t                        \"pagetype\":0,\r\n\t\t                        \"sizes\":[[300,250]],\r\n\t\t                        \"bids\":[{\r\n\t\t                            \"bidder\":\"appnexus\",\r\n\t\t                            \"params\":{\"placementId\": pID}\r\n\t\t                        }]\r\n\t\t                    }\r\n\t\t                   \r\n\t\t                ],\r\n\t\t                \"Base Leaderboard\":[\r\n\t\t                \t{\r\n\t\t                        \"platform\":\"desktop\",\r\n\t\t                        \"pagetype\":0,\r\n\t\t                        \"sizes\":[[728,90],[970,90],[970,250]],\r\n\t\t                        \"bids\":[{\r\n\t\t                            \"bidder\":\"appnexus\",\r\n\t\t                            \"params\":{\"placementId\": pID}\r\n\t\t                        }]\r\n\t\t\t\t\t\t\t},{\r\n\t\t                        \"platform\":\"mobile\",\r\n\t\t                        \"pagetype\":0,\r\n\t\t                        \"sizes\":[[320,50],[300,250]],\r\n\t\t                        \"bids\":[{\r\n\t\t                            \"bidder\":\"appnexus\",\r\n\t\t                            \"params\":{\"placementId\": pID}\r\n\t\t                        }]\r\n\t\t\t\t\t\t\t}\r\n\t\t\t\t\t\t]\r\n\t\t\t\t\t  },\r\n\t\t\t\t\t  \"roundingBuckets\": {\r\n\t\t\t                \"max\": 20.00,\r\n\t\t\t                \"type\": 1,\r\n\t\t\t                \"buckets\": [{\r\n\t\t\t                    \"range\": [0, 20],\r\n\t\t\t                    \"granularity\": 0.05\r\n\t\t\t                }]\r\n\t\t\t            }\r\n\t\t                \r\n\t\t            },\r\n\t\t            \"INDX\": {\r\n\t\t                \"targetingType\": \"slot\",\r\n\t\t                \"timeout\": 600\r\n\t\t            }\r\n\t\t        }\r\n\t\t    };\r\n\t\t }\r\n    }\r\n    catch(e){\r\n\t\tdebug.log(\"Error configuring Index Header Wrapper\"+e)\r\n\t}"
		});
	},
	
	/**
	 * Load Library
	 */
	"loadLibrary": function(){
		__gh__webApp.common.loadScript({
			"src": "http://js.indexww.com/ht/htw-gatehouse-v2.js"
		});
	},
	/**
	 * Load GPT Fallback 
	 //If there were an event in which the Header Tag Wrapper did not load, the Google Publisher Tag would resume its regular behaviour.
	 googletag.cmd.push(function() {
		if (typeof window.headertag === 'undefined' || window.headertag.apiReady !== true) { 
		 window.headertag = googletag;
		} 
	});
	 */
	"loadFallback": function(){
		
		__gh__webApp.common.loadScript({
			"text"			: "googletag.cmd.push(function() {\r\n\tif (typeof window.headertag === \'undefined\' || window.headertag.apiReady !== true) { \r\n\t window.headertag = googletag;\r\n\t} \r\n});"
		});
	},
	
	


};


/*
|--------------------------------------------------------------------------
| Ads: Amazon Direct Match Buy
|--------------------------------------------------------------------------
*/
/**
 * @namespace- Amazon header bidding integration
 */
__gh__webApp.ads.amazonHeader = {

	/**
	 * Initialize
	var amznads = amznads || {};
	    var googletag = googletag || {};
	    googletag.cmd = googletag.cmd || [];
	    amznads.asyncParams = {
	        'id': '3252',
	        'callbackFn': function() {
	            try {
		           	//debug.log('Amazon Direct Match callback')
	                amznads.setTargetingForGPTAsync('amznslots');
	            } catch (e) { 
		            debug.log('Amazon Direct Match init error.'+e)
		             }
		   //Continue your DFP call here (optional) 
		   try {   
		   __gh__webApp.ads.dfp.init();
		   __gh__webApp.utilities.lazyAds.init();
		   __gh__coreData.globalVariables.amzHeader.startTime=__gh__webApp.common.timer();
		   //debug.log('Amazon Direct Match START TIME.'+__gh__coreData.globalVariables.amzHeader.startTime)
		   } catch (e) { 
		            debug.log('Error init DFp in AMAzon header.'+e)
		             }
	        },
	        'timeout': 2e3
	    };
	    (function() {
	        var a, s = document.getElementsByTagName("script")[0];
	        a = document.createElement("script");
	        a.type = "text/javascript";
	        a.async = true;
	        a.src = "http://c.amazon-adsystem.com/aax2/amzn_ads.js";
	        s.parentNode.insertBefore(a, s);
	    })();
	 */
	"init": function(){
		__gh__coreData.globalVariables.amzHeader = __gh__coreData.globalVariables.amzHeader|| {},
		__gh__coreData.globalVariables.amzHeader.startTime = '',
		__gh__coreData.globalVariables.amzHeader.currTime = '';
		//Load Amazon Script to retreive ads
		//debug.log('Amazon Direct Match init')
		this.getAds();
	},
	
	/**
	 * Retrieve ads
	 */
	"getAds": function(){
		//debug.log('Amazon Direct Match init. Start get ads.')
		
		__gh__webApp.common.loadScript({
			"text"			: "var amznads = amznads || {};\r\n\t    var googletag = googletag || {};\r\n\t    googletag.cmd = googletag.cmd || [];\r\n\t    amznads.asyncParams = {\r\n\t        \'id\': \'3252\',\r\n\t        \'callbackFn\': function() {\r\n\t            try {\r\n\t                amznads.setTargetingForGPTAsync(\'amznslots\');\r\n\t            } catch (e) { \r\n\t\t            debug.log(\'Amazon Direct Match init error.\'+e)\r\n\t\t             }\r\n\t\t   try {   \r\n\t\t   __gh__webApp.ads.dfp.init();\r\n\t\t   __gh__webApp.utilities.lazyAds.init();\r\n\t\t   __gh__coreData.globalVariables.amzHeader.startTime=__gh__webApp.common.timer();\r\n\t\t   } catch (e) { \r\n\t\t            debug.log(\'Error init DFp in AMAzon header.\'+e)\r\n\t\t             }\r\n\t        },\r\n\t        \'timeout\': 2e3\r\n\t    };\r\n\t    (function() {\r\n\t        var a, s = document.getElementsByTagName(\"script\")[0];\r\n\t        a = document.createElement(\"script\");\r\n\t        a.type = \"text\/javascript\";\r\n\t        a.async = true;\r\n\t        a.src = \"http:\/\/c.amazon-adsystem.com\/aax2\/amzn_ads.js\";\r\n\t        s.parentNode.insertBefore(a, s);\r\n\t    })();"
		});
		
		
	},
	
	/**
	 * Retrieve ads
	 */
	"lazyInit": function(){
		var thisObject=this,
			runLazy=false;
		try {
			//googletag.pubads().clearTargeting('amznslots'); // clear custom targeting value by key
			
			var testKey='amzn_debug_mode';
			
			
			__gh__coreData.globalVariables.amzHeader.currTime=__gh__webApp.common.timer();
			
			runLazy=thisObject.timer(__gh__coreData.globalVariables.amzHeader.startTime,__gh__coreData.globalVariables.amzHeader.currTime);
			
			if(runLazy==true){
				//debug.log('START: Enough time passed. Amazon Direct Match called.')
				//if(__gh__webApp.utilities.GetURLParameter.init(testKey)=='1'){debugger;}
				amznads.getAdsCallback('3252', __gh__webApp.ads.amazonHeader.lazyCallback);
				//if(__gh__webApp.utilities.GetURLParameter.init(testKey)=='1'){debugger;}
				__gh__coreData.globalVariables.amzHeader.startTime=__gh__webApp.common.timer();//reset start time
				//debug.log('END: Enough time passed. Amazon Direct Match called. ')
			}
			else{
				__gh__webApp.ads.dfp.createLazySlot();
				//debug.log('Not enough time passed. Amazon Direct Match not called.')
			}
		    
		    
		} 
		catch (e) {
		    debug.log('Amazon Direct Match lazyInit error.'+e)
		}
	},
	
	/**
	 * Retrieve ads
	 */
	"lazyCallback": function(){
		var testKey='amzn_debug_mode';
			//debug.log('Amazon Direct Match lazy callback.')
			//if(__gh__webApp.utilities.GetURLParameter.init(testKey)=='1'){debugger;}
			amznads.setTargetingForGPTAsync('amznslots');   // reset custom targeting value by key   
			__gh__webApp.ads.dfp.createLazySlot();
	},
	
	/**
	 * Check Timer: 10 seconds should pass before next Amazon call.
	 */
	"timer": function(start,current){
		//debug.log('Amazon Direct Match lazy callback.')
			var timeDiff=current-start;
			//debug.log('Amazon Direct Match TIME PASSED= '+timeDiff)
			if(timeDiff>=10000){
				return true;
			}
			else{
				return false;
			}
	}

};







/*
|--------------------------------------------------------------------------
| Analytics: Krux
|--------------------------------------------------------------------------
*/
/**
 * @namespace
 */
__gh__webApp.analytics.krux = {
	
	/**
	 * Initialize
	 */
	"init": function(){
		var commonJS		= __gh__webApp.common,
			checkDFPId		= commonJS.isObjectPropertySet(__gh__coreData["3rdPartyData"],"ads.dfp.id");
			if(!checkDFPId){debug.info("DFP ID is not set.");return;}
		var dfpNetworkId 	= __gh__coreData["3rdPartyData"].ads.dfp.id;
		this.loadControlTag();
		if (dfpNetworkId == 11564835){
			this.loadInterchangeCode();
		}
		//this.refreshData();
		
	},
	
	
	/**
	 * Load the krux control tag
	 */
	"loadControlTag": function(){
		var commonJS		= __gh__webApp.common,
			checkKruxId		= commonJS.isObjectPropertySet(__gh__coreData["3rdPartyData"],"analytics.krux.id");
			var track = __gh__coreData.siteData.providers.analytics.track_krux;
			if (!track) { return; }
			if(!checkKruxId){debug.info("Krux ID is not set.");return;}
		var kruxId 			= __gh__coreData["3rdPartyData"].analytics.krux.id;
		__gh__webApp.common.loadScript({
			"class"				: "kxct",
			"dataAttributes"	: {
				"id"			: kruxId,
				"timing" 		: "async",
				"version"		: "1.9",
			},
			"text"				: "\twindow.Krux||((Krux=function(){Krux.q.push(arguments)}).q=[]);\r\n\t(function(){\r\n\t\tvar k=document.createElement(\'script\');k.type=\'text\/javascript\';k.async=true;\r\n\t\tvar m,src=(m=location.href.match(\/\\bkxsrc=([^&]+)\/))&&decodeURIComponent(m[1]);\r\n\t\tk.src = \/^https?:\\\/\\\/([a-z0-9_\\-\\.]+\\.)?krxd\\.net(:\\d{1,5})?\\\/\/i.test(src) ? src : src === \"disable\" ? \"\" :\r\n\t\t(location.protocol===\"https:\"?\"https:\":\"http:\")+\"\/\/cdn.krxd.net\/controltag?confid="+kruxId+"\"\r\n\t\t;\r\n\t\tvar s=document.getElementsByTagName(\'script\')[0];s.parentNode.insertBefore(k,s);\r\n\t}());"
		});
	},
	
	
	/**
	 * Load the krux interchange code
	 */
	"loadInterchangeCode": function(){
		__gh__webApp.common.loadScript({
			"class"			: "kxint",
			"text"			: "window.Krux||((Krux=function(){Krux.q.push(arguments);}).q=[]);\r\n(function(){\r\n\tfunction retrieve(n){\r\n\t\tvar m, k=\'kxgatehouse_\'+n;\r\n\t\tif (window.localStorage) {\r\n\t\t\treturn window.localStorage[k] || \"\";\r\n\t\t} else if (navigator.cookieEnabled) {\r\n\t\t\tm = document.cookie.match(k+\'=([^;]*)\');\r\n\t\t\treturn (m && unescape(m[1])) || \"\";\r\n\t\t} else {\r\n\t\treturn \'\';\r\n\t\t}\r\n\t}\r\n\tKrux.user = retrieve(\'user\');\r\n\tKrux.segments = retrieve(\'segs\') && retrieve(\'segs\').split(\',\') || [];\r\n})();"
		});
	},
	
	"refreshData": function(){
		
		Krux('ns:gatehouse', 'page:load', function(err) {
		/* Optional, called just after the tags are finished loading. 
		 If err is not null, then something went wrong. (err will be an instance of Error or null.)
		*/
		debug.info('Krux data refresh. err='+err);
		}, {pageView: true /* Set to false if you don't want this counted as a page view. */});
			
				
	},
};



/*

|--------------------------------------------------------------------------
| Analytics: Genesis
|--------------------------------------------------------------------------
*/
/**
 * @namespace -- THIS is being Loaded asynchronously  
 */
__gh__webApp.analytics.genesis = {
	
	/**
	 * Initialize
	 */
	"init": function(){
		__gh__webApp.common.loadScript({
			"src": "http://adg.bzgint.com/pub/adg/data.js"
		});
	}

};



/*
|--------------------------------------------------------------------------
| Utilities: Lazy Ads
|--------------------------------------------------------------------------
*/
/**
 * Lazy Ads
 * @namespace
 */
  //<----- RYAN EDIT
__gh__webApp.utilities.lazyAds = {
	"init": function(){
		this.bindEvents();	
	},
	
	"loadAds": function(){
		try{
			var gcsParagraphsDOM 	= ".t402-elided",
			$loadAd 			= $("[data-gh-lazy-ad-loaded=false]").not(gcsParagraphsDOM).first(); 
			//Prevent funciton from trying to load ads if there is a consumer survey in place….
			//google adds a class to the mark up and then it get’s removed once you complete the survey
		
		}
		catch(e){
			debug.info('Error with gcsParagraphsDOM for google survey. '+e)
			var $loadAd = $("[data-gh-lazy-ad-loaded=false]").first();
		}

		//Check to see if load ad
		if ($loadAd.length && $loadAd.isOnScreen()){
			// find ad dom
			// create ad code
			// load ad
	    	
	    	$loadAd.attr("data-gh-lazy-ad-loaded",true);
	    	
	    	//only load ad once
	    	 //Lazy Load ad
	    	/*var testKey='testing';
		    if(__gh__webApp.utilities.GetURLParameter.init(testKey)=='amazonDirect'){*/
				__gh__webApp.ads.amazonHeader.lazyInit();
			/*}
			else{
		    	__gh__webApp.ads.dfp.createLazySlot(); 
	    	}*/
	    }
	},
	
	"bindEvents": function(){
		//Load more ads on scroll
		//var efficientLoadMoreFn = __gh__webApp.common.debounce(this.loadAds, 0);//debouce if effectlively disabled by being set to zero
		//$(document).on("scroll.gh-lazy-ads",efficientLoadMoreFn);
		
		$(document).on("scroll.gh-lazy-ads",this.loadAds);
		//$(document).on("scroll.gh-infinite-scroll",this.loadMore);
		//$(document).on("scroll.gh-infinite-scroll-at-bottom",this.loadMoreAtPageBottom);
	},
	
	"onloadLazyAds": function(container){
		var $lazyLoadAd = $( container );
		$lazyLoadAd.each(function( index ) {
		  __gh__webApp.ads.dfp.createLazySlot(container);
		});
	}
};




/*	
|--------------------------------------------------------------------------
| Template AppNexus Placement IDs: DFP
|--------------------------------------------------------------------------
*/
/**
 * @namespace --  
 */


var appNexusIds = {
	"default": {
		"heraldtribune.com": {"pid":"9430019"},
		"cantonrep.com": {
			"pid":	"9429933"
		},
		"capecodtimes.com": {
			"pid":	"9429937"
		},
		"gainesville.com": {
			"pid":	"9429995"
		},
		"pjstar.com": {
			"pid":	"9430120"
		},
		"recordonline.com": {
			"pid":	"9430135"
		},
		"seacoastonline.com": {
			"pid":	"9430147"
		},
		"sj-r.com": {
			"pid":	"9430154"
		},
		"starnewsonline.com": {
			"pid":	"9430163"
		},
		"telegram.com": {
			"pid":	"9430174"
		},
		"theledger.com": {
			"pid":	"9430185"
		},
		"providencejournal.com": {
			"pid":	"9529398"
		},
		"ack.net": {"pid":"9429894"},
		"adelnews.com": {"pid":"9429895"},
		"advocatepress.com": {"pid":"9429896"},
		"agjournalonline.com": {"pid":"9429897"},
		"aledotimesrecord.com": {"pid":"9429898"},
		"alicetx.com": {"pid":"9429899"},
		"americanvalor.net": {"pid":"9429900"},
		"amestrib.com": {"pid":"9429901"},
		"amtrib.com": {"pid":"9429902"},
		"andoveramerican.com": {"pid":"9429903"},
		"apalachtimes.com": {"pid":"9429904"},
		"applevalley-review.com": {"pid":"9429905"},
		"ardmoreite.com": {"pid":"9429906"},
		"arkansasnews.com": {"pid":"9429907"},
		"weeklycitizen.com": {"pid":"9429908"},
		"augustagazette.com": {"pid":"9429909"},
		"auroraadvertiser.net": {"pid":"9429910"},
		"azcapitoltimes.com": {"pid":"9429911"},
		"ballingerledger.com": {"pid":"9429912"},
		"barnstablepatriot.com": {"pid":"9429913"},
		"bastropenterprise.com": {"pid":"9429914"},
		"bcdemocratonline.com": {"pid":"9429915"},
		"bedfordnow.com": {"pid":"9429916"},
		"bentoneveningnews.com": {"pid":"9429917"},
		"bignickel.com": {"pid":"9429918"},
		"bluejacketsxtra.com": {"pid":"9429919"},
		"blueridgenow.com": {"pid":"9429920"},
		"boonevilledemocrat.com": {"pid":"9429922"},
		"boonvilledailynews.com": {"pid":"9429923"},
		"bouldercityreview.com": {"pid":"9429924"},
		"brightonpittsfordpost.com": {"pid":"9429925"},
		"brownwoodtx.com": {"pid":"9429926"},
		"Buckeyextra.com": {"pid":"9429927"},
		"butlercountytimesgazette.com": {"pid":"9429928"},
		"cambridgechron.com": {"pid":"9429929"},
		"cantondailyledger.com": {"pid":"9429930"},
		"capecodonline.com": {"pid":"9429935"},
		"capecodrealestate.com": {"pid":"9429936"},
		"carmitimes.com": {"pid":"9429938"},
		"carthagepress.com": {"pid":"9429939"},
		"charlestonexpress.com": {"pid":"9429940"},
		"cheboygannews.com": {"pid":"9429941"},
		"chillicothenews.com": {"pid":"9429942"},
		"chillicothetimesbulletin.com": {"pid":"9429943"},
		"chipleypaper.com": {"pid":"9429944"},
		"chronicle-express.com": {"pid":"9429945"},
		"columbiadailyherald.com": {"pid":"9429946"},
		"columbusalive.com": {"pid":"9429947"},
		"columbusbride.com": {"pid":"9429948"},
		"columbusceo.com": {"pid":"9429949"},
		"columbuscrave.com": {"pid":"9429950"},
		"columbusmonthly.com": {"pid":"9429951"},
		"columbusparent.com": {"pid":"9429952"},
		"hockessincommunitynews.com": {"pid":"9429953"},
		"courier-tribune.com": {"pid":"9429954"},
		"crestviewbulletin.com": {"pid":"9429955"},
		"crookstontimes.com": {"pid":"9429956"},
		"dailyamericannews.com": {"pid":"9429957"},
		"dailycomet.com": {"pid":"9429958"},
		"dailycommercial.com": {"pid":"9429959"},
		"dailyregister.com": {"pid":"9429960"},
		"dailyreporter.com": {"pid":"9429961"},
		"dailyrepublicannews.com": {"pid":"9429962"},
		"dailytidings.com": {"pid":"9429963"},
		"dansvilleonline.com": {"pid":"9429964"},
		"deridderdailynews.com": {"pid":"9429965"},
		"desertdispatch.com": {"pid":"9429966"},
		"destin.com": {"pid":"9429967"},
		"devilslakejournal.com": {"pid":"9429968"},
		"djcgulfcoast.com": {"pid":"9429970"},
		"djcoregon.com": {"pid":"9429971"},
		"dodgeglobe.com": {"pid":"9429972"},
		"donaldsonvillechief.com": {"pid":"9429973"},
		"doverpost.com": {"pid":"9429974"},
		"duquoin.com": {"pid":"9429975"},
		"eastpeoriatimescourier.com": {"pid":"9429976"},
		"echo-pilot.com": {"pid":"9429977"},
		"edinburgreview.com": {"pid":"9429978"},
		"eglindispatch.com": {"pid":"9429979"},
		"eldoradotimes.com": {"pid":"9429980"},
		"elmojave.com": {"pid":"9429981"},
		"eltiempolv.com": {"pid":"9429982"},
		"emeraldcoast.com": {"pid":"9429983"},
		"enterprisenews.com": {"pid":"9429984"},
		"eveningtribune.com": {"pid":"9429985"},
		"examiner-enterprise.com": {"pid":"9429986"},
		"examiner.net": {"pid":"9429987"},
		"fairportpost.com": {"pid":"9429988"},
		"finance-commerce.com": {"pid":"9429989"},
		"fosters.com": {"pid":"9429990"},
		"fowlertribune.com": {"pid":"9429991"},
		"fridaynightohio.com": {"pid":"9429992"},
		"gadsdentimes.com": {"pid":"9429994"},
		"galesburg.com": {"pid":"9429996"},
		"galvanews.com": {"pid":"9429997"},
		"gastongazette.com": {"pid":"9429998"},
		"gateschilipost.com": {"pid":"9430000"},
		"gatorsports.com": {"pid":"9430001"},
		"geneseorepublic.com": {"pid":"9430002"},
		"goupstate.com": {"pid":"9430003"},
		"grandlakenews.com": {"pid":"9430004"},
		"granitefallsnews.com": {"pid":"9430005"},
		"greecepost.com": {"pid":"9430006"},
		"greenwooddemocrat.com": {"pid":"9430007"},
		"gridleyherald.com": {"pid":"9430008"},
		"grimestoday.com": {"pid":"9430009"},
		"gruperalv.com": {"pid":"9430010"},
		"gulfdefender.com": {"pid":"9430011"},
		"hamburgreporter.com": {"pid":"9430012"},
		"hannibal.net": {"pid":"9430013"},
		"havenews.com": {"pid":"9430014"},
		"helena-arkansas.com": {"pid":"9430015"},
		"henriettapost.com": {"pid":"9430016"},
		"herald-democrat.com": {"pid":"9430017"},
		"heraldnews.com": {"pid":"9430018"},
		"hesperiastar.com": {"pid":"9430020"},
		"hillsdale.net": {"pid":"9430021"},
		"hollandsentinel.com": {"pid":"9430022"},
		"homesplusmonroe.com": {"pid":"9430023"},
		"hopestar.com": {"pid":"9430024"},
		"houmatoday.com": {"pid":"9430025"},
		"hsvvoice.com": {"pid":"9430026"},
		"hurlburtwarrior.com": {"pid":"9430027"},
		"idahobusinessreview.com": {"pid":"9430028"},
		"indeonline.com": {"pid":"9430029"},
		"irondequoitpost.com": {"pid":"9430030"},
		"jacksonnewspapers.com": {"pid":"9430031"},
		"jdnews.com": {"pid":"9430032"},
		"journaldemocrat.com": {"pid":"9430033"},
		"journalrecord.com": {"pid":"9430034"},
		"journalstandard.com": {"pid":"9430035"},
		"kinston.com": {"pid":"9430036"},
		"kiowacountysignal.com": {"pid":"9430037"},
		"kirksvilledailyexpress.com": {"pid":"9430038"},
		"lajuntatribunedemocrat.com": {"pid":"9430039"},
		"lakesunleader.com": {"pid":"9430040"},
		"laredosbargainbook.com": {"pid":"9430041"},
		"leaderjournal.com": {"pid":"9430042"},
		"leavenworthtimes.com": {"pid":"9430043"},
		"leesvilledailyleader.com": {"pid":"9430044"},
		"lenconnect.com": {"pid":"9430045"},
		"libn.com": {"pid":"9430046"},
		"lincolncourier.com": {"pid":"9430047"},
		"linncountyleader.com": {"pid":"9430048"},
		"littlefallstimes.com": {"pid":"9430049"},
		"localmediagroupinc.com": {"pid":"9430050"},
		"lonokenews.net": {"pid":"9430051"},
		"lucernevalleyleader.com": {"pid":"9430052"},
		"luxurylv.com": {"pid":"9430053"},
		"lvbusinesspress.com": {"pid":"9430054"},
		"mackinacjournal.com": {"pid":"9430055"},
		"macombjournal.com": {"pid":"9430056"},
		"mailtribune.com": {"pid":"9430057"},
		"masslawyersweekly.com": {"pid":"9430058"},
		"masspoliticalnews.com": {"pid":"9430059"},
		"mcphersonsentinel.com": {"pid":"9430060"},
		"mecktimes.com": {"pid":"9430061"},
		"medfordnickel.com": {"pid":"9430062"},
		"metrowestdailynews.com": {"pid":"9430063"},
		"mexicoledger.com": {"pid":"9430064"},
		"miamiok.com": {"pid":"9430065"},
		"middletowntranscript.com": {"pid":"9430066"},
		"midlothianmirror.com": {"pid":"9430067"},
		"milawyersweekly.com": {"pid":"9430068"},
		"milfordbeacon.com": {"pid":"9430069"},
		"milforddailynews.com": {"pid":"9430070"},
		"minnlawyer.com": {"pid":"9430071"},
		"moberlymonitor.com": {"pid":"9430072"},
		"molawyersmedia.com": {"pid":"9430073"},
		"monroenews.com": {"pid":"9430074"},
		"monroeparent.com": {"pid":"9430075"},
		"monroetalks.com": {"pid":"9430076"},
		"montenews.com": {"pid":"9430077"},
		"morecontentnow": {"pid":"9430078"},
		"morningsun.net": {"pid":"9430079"},
		"mortontimesnews.com": {"pid":"9430080"},
		"moscowvillager.com": {"pid":"9430081"},
		"mpnnow.com": {"pid":"9430082"},
		"mtshastanews.com": {"pid":"9430083"},
		"nclawyersweekly.com": {"pid":"9430084"},
		"ncnewspress.com": {"pid":"9430085"},
		"neagle.com": {"pid":"9430086"},
		"Nemotrader.net": {"pid":"9430087"},
		"neoshodailynews.com": {"pid":"9430088"},
		"nevadaiowajournal.com": {"pid":"9430089"},
		"nevadapreps.com": {"pid":"9430090"},
		"newbernsj.com": {"pid":"9430091"},
		"neworleanscitybusiness.com": {"pid":"9430092"},
		"newportindependent.com": {"pid":"9430093"},
		"news-journalonline.com": {"pid":"9430094"},
		"news-star.com": {"pid":"9430095"},
		"newschief.com": {"pid":"9430096"},
		"newsherald.com": {"pid":"9430097"},
		"newssun.com": {"pid":"9430098"},
		"newstribune.info": {"pid":"9430099"},
		"wickedlocal.com/northofboston": {"pid":"9430100"},
		"northneighbornews.com": {"pid":"9430101"},
		"norwichbulletin.com": {"pid":"9430102"},
		"nwfdailynews.com": {"pid":"9430103"},
		"nydailyrecord.com": {"pid":"9430104"},
		"oakridger.com": {"pid":"9430105"},
		"ocala.com": {"pid":"9430106"},
		"ojornal.com": {"pid":"9430107"},
		"olneydailymail.com": {"pid":"9430108"},
		"oncape.com": {"pid":"9430109"},
		"oriongazette.com": {"pid":"9430110"},
		"pahrumpvalleytimes.com": {"pid":"9430111"},
		"paris-express.com": {"pid":"9430112"},
		"patriotledger.com": {"pid":"9430113"},
		"pawhuskajournalcapital.com": {"pid":"9430114"},
		"pbcommercial.com": {"pid":"9430115"},
		"pekintimes.com": {"pid":"9430116"},
		"penfieldpost.com": {"pid":"9430117"},
		"peopleforpeoplefund.com": {"pid":"9430118"},
		"picayune-times.com": {"pid":"9430119"},
		"poconorecord.com": {"pid":"9430121"},
		"politicsinminnesota.com": {"pid":"9430122"},
		"pontiacdailyleader.com": {"pid":"9430123"},
		"postsouth.com": {"pid":"9430124"},
		"poststarnews.com": {"pid":"9430125"},
		"prairiestateoutdoors.com": {"pid":"9430126"},
		"pratttribune.com": {"pid":"9430127"},
		"pressargus.com": {"pid":"9430128"},
		"pressmentor.com": {"pid":"9430129"},
		"progress-index.com": {"pid":"9430130"},
		"prosperpressnews.com": {"pid":"9430131"},
		"pulaskinews.net": {"pid":"9430132"},
		"randolphcountyheraldtribune.com": {"pid":"9430133"},
		"recordnet.com": {"pid":"9430134"},
		"recordstar.com": {"pid":"9430136"},
		"redwoodfallsgazette.com": {"pid":"9430137"},
		"reviewatlas.com": {"pid":"9430138"},
		"rhodeisland.com": {"pid":"9430139"},
		"ridgecrestca.com": {"pid":"9430140"},
		"rilawyersweekly.com": {"pid":"9430141"},
		"rockfordparent.com": {"pid":"9430142"},
		"rrstar.com": {"pid":"9430143"},
		"savingsenseonline.com": {"pid":"9430144"},
		"sclawyersweekly.com": {"pid":"9430145"},
		"scsuntimes.com": {"pid":"9430146"},
		"sekvoice.com": {"pid":"9430148"},
		"sentinel-standard.com": {"pid":"9430149"},
		"shelbystar.com": {"pid":"9430150"},
		"siftingsherald.com": {"pid":"9430151"},
		"siskiyoudaily.com": {"pid":"9430152"},
		"sitraders.com": {"pid":"9430153"},
		"sjnewsonline.com": {"pid":"9430155"},
		"sleepyeyenews.com": {"pid":"9430156"},
		"sooeveningnews.com": {"pid":"9430157"},
		"southcoasttoday.com": {"pid":"9430158"},
		"southlakepress.com": {"pid":"9430159"},
		"srpressgazette.com": {"pid":"9430160"},
		"starcourier.com": {"pid":"9430161"},
		"starfl.com": {"pid":"9430162"},
		"steubencourier.com": {"pid":"9430164"},
		"stjamesnews.com": {"pid":"9430165"},
		"storycityherald.com": {"pid":"9430166"},
		"sturgisjournal.com": {"pid":"9430167"},
		"stuttgartdailyleader.com": {"pid":"9430168"},
		"sulphurdailynews.com": {"pid":"9430169"},
		"sussexcountian.com": {"pid":"9430170"},
		"swtimes.com": {"pid":"9430171"},
		"taftmidwaydriller.com": {"pid":"9430172"},
		"tauntongazette.com": {"pid":"9430173"},
		"teutopolispress.com": {"pid":"9430175"},
		"the-dispatch.com": {"pid":"9430176"},
		"the-leader.com": {"pid":"9430177"},
		"thebag.com": {"pid":"9430178"},
		"thecarbondalenews.com": {"pid":"9430179"},
		"thedailyrecord.com": {"pid":"9430180"},
		"thedailyreporter.com": {"pid":"9430181"},
		"thedestinlog.com": {"pid":"9430182"},
		"thegurdontimes.com": {"pid":"9430183"},
		"thekansan.com": {"pid":"9430184"},
		"theperrychief.com": {"pid":"9430186"},
		"therecordherald.com": {"pid":"9430187"},
		"thered7.net": {"pid":"9430188"},
		"therolladailynews.com": {"pid":"9430189"},
		"thesuburbanite.com": {"pid":"9430190"},
		"thesuntimes.com": {"pid":"9430191"},
		"thetimesnews.com": {"pid":"9430192"},
		"thisweeknews.com": {"pid":"9430193"},
		"thisweeksports.com": {"pid":"9430194"},
		"tidesports.com": {"pid":"9430195"},
		"timesreporter.com": {"pid":"9430196"},
		"timestelegram.com": {"pid":"9430197"},
		"topsailadvertiser.com": {"pid":"9430198"},
		"tricountytimes.com": {"pid":"9430199"},
		"tuscaloosanews.com": {"pid":"9430200"},
		"uticaod.com": {"pid":"9430201"},
		"valawyersweekly.com": {"pid":"9430202"},
		"vanalstyneleader.net": {"pid":"9430203"},
		"vanburencountydem.com": {"pid":"9430204"},
		"victorpost.com": {"pid":"9430205"},
		"vvdailypress.com": {"pid":"9430206"},
		"waltonsun.com": {"pid":"9430207"},
		"washingtontimesreporter.com": {"pid":"9430209"},
		"waxahachietx.com": {"pid":"9430210"},
		"wayneindependent.com": {"pid":"9430211"},
		"waynepost.com": {"pid":"9430212"},
		"waynesvilledailyguide.com": {"pid":"9430213"},
		"websterpost.com": {"pid":"9430214"},
		"wellingtondailynews.com": {"pid":"9430215"},
		"wellsvilledaily.com": {"pid":"9430216"},
		"whitehalljournal.com": {"pid":"9430217"},
		"wickedlocal.com": {"pid":"9430219"},
		"wickedlocal.com/abington": {"pid":"9430220"},
		"wickedlocal.com/acton": {"pid":"9430221"},
		"wickedlocal.com/allston": {"pid":"9430222"},
		"wickedlocal.com/amesbury": {"pid":"9430223"},
		"wickedlocal.com/arlington": {"pid":"9430224"},
		"wickedlocal.com/ashland": {"pid":"9430225"},
		"wickedlocal.com/avon": {"pid":"9430226"},
		"wickedlocal.com/barnstable": {"pid":"9430227"},
		"wickedlocal.com/bedford": {"pid":"9430228"},
		"wickedlocal.com/bellingham": {"pid":"9430229"},
		"wickedlocal.com/belmont": {"pid":"9430230"},
		"wickedlocal.com/berkley": {"pid":"9430231"},
		"wickedlocal.com/beverly": {"pid":"9430232"},
		"wickedlocal.com/billerica": {"pid":"9430233"},
		"wickedlocal.com/bolton": {"pid":"9430234"},
		"wickedlocal.com/bourne": {"pid":"9430235"},
		"wickedlocal.com/boxborough": {"pid":"9430236"},
		"wickedlocal.com/boxford": {"pid":"9430237"},
		"wickedlocal.com/braintree": {"pid":"9430238"},
		"wickedlocal.com/brewster": {"pid":"9430239"},
		"wickedlocal.com/bridgewater": {"pid":"9430240"},
		"wickedlocal.com/bridgewatereast": {"pid":"9430241"},
		"wickedlocal.com/bridgewaterwest": {"pid":"9430242"},
		"wickedlocal.com/brockton": {"pid":"9430243"},
		"wickedlocal.com/brookline": {"pid":"9430244"},
		"wickedlocal.com/burlington": {"pid":"9430245"},
		"wickedlocal.com/cambridge": {"pid":"9430246"},
		"wickedlocal.com/canton": {"pid":"9430247"},
		"wickedlocal.com/capecod": {"pid":"9430248"},
		"wickedlocal.com/carver": {"pid":"9430249"},
		"wickedlocal.com/chatham": {"pid":"9430250"},
		"wickedlocal.com/chelmsford": {"pid":"9430251"},
		"wickedlocal.com/clinton": {"pid":"9430252"},
		"wickedlocal.com/cohasset": {"pid":"9430253"},
		"wickedlocal.com/concord": {"pid":"9430254"},
		"wickedlocal.com/danvers": {"pid":"9430255"},
		"wickedlocal.com/Dedham": {"pid":"9430256"},
		"wickedlocal.com/dennis": {"pid":"9430257"},
		"wickedlocal.com/dighton": {"pid":"9430258"},
		"wickedlocal.com/dover": {"pid":"9430259"},
		"wickedlocal.com/duxbury": {"pid":"9430260"},
		"wickedlocal.com/eastham": {"pid":"9430261"},
		"wickedlocal.com/easton": {"pid":"9430262"},
		"wickedlocal.com/essex": {"pid":"9430263"},
		"wickedlocal.com/fall-river": {"pid":"9430264"},
		"wickedlocal.com/falmouth": {"pid":"9430265"},
		"wickedlocal.com/foxborough": {"pid":"9430266"},
		"wickedlocal.com/framingham": {"pid":"9430267"},
		"wickedlocal.com/franklin": {"pid":"9430268"},
		"wickedlocal.com/georgetown": {"pid":"9430269"},
		"wickedlocal.com/gloucester": {"pid":"9430270"},
		"wickedlocal.com/halifax": {"pid":"9430271"},
		"wickedlocal.com/hamilton": {"pid":"9430272"},
		"wickedlocal.com/hanover": {"pid":"9430273"},
		"wickedlocal.com/hanson": {"pid":"9430274"},
		"wickedlocal.com/harvard": {"pid":"9430275"},
		"wickedlocal.com/harwich": {"pid":"9430276"},
		"wickedlocal.com/hingham": {"pid":"9430277"},
		"wickedlocal.com/holbrook": {"pid":"9430278"},
		"wickedlocal.com/holliston": {"pid":"9430279"},
		"wickedlocal.com/hopedale": {"pid":"9430280"},
		"wickedlocal.com/hopkinton": {"pid":"9430281"},
		"wickedlocal.com/hudson": {"pid":"9430282"},
		"wickedlocal.com/hull": {"pid":"9430283"},
		"wickedlocal.com/ipswich": {"pid":"9430284"},
		"wickedlocal.com/kingston": {"pid":"9430285"},
		"wickedlocal.com/lakeville": {"pid":"9430286"},
		"wickedlocal.com/lancaster": {"pid":"9430287"},
		"wickedlocal.com/lexington": {"pid":"9430288"},
		"wickedlocal.com/lincoln": {"pid":"9430289"},
		"wickedlocal.com/littleton": {"pid":"9430290"},
		"wickedlocal.com/malden": {"pid":"9430291"},
		"wickedlocal.com/manchester": {"pid":"9430292"},
		"wickedlocal.com/mansfield": {"pid":"9430293"},
		"wickedlocal.com/marblehead": {"pid":"9430294"},
		"wickedlocal.com/marion": {"pid":"9430295"},
		"wickedlocal.com/marlborough": {"pid":"9430296"},
		"wickedlocal.com/marshfield": {"pid":"9430297"},
		"wickedlocal.com/mashpee": {"pid":"9430298"},
		"wickedlocal.com/mattapoisett": {"pid":"9430299"},
		"wickedlocal.com/maynard": {"pid":"9430300"},
		"wickedlocal.com/medfield": {"pid":"9430301"},
		"wickedlocal.com/medford": {"pid":"9430302"},
		"wickedlocal.com/medway": {"pid":"9430303"},
		"wickedlocal.com/melrose": {"pid":"9430304"},
		"wickedlocal.com/mendon": {"pid":"9430305"},
		"wickedlocal.com/middleborough": {"pid":"9430306"},
		"wickedlocal.com/middleton": {"pid":"9430307"},
		"wickedlocal.com/milford": {"pid":"9430308"},
		"wickedlocal.com/millis": {"pid":"9430309"},
		"wickedlocal.com/milton": {"pid":"9430310"},
		"wickedlocal.com/natick": {"pid":"9430311"},
		"wickedlocal.com/needham": {"pid":"9430312"},
		"wickedlocal.com/newburyport": {"pid":"9430313"},
		"wickedlocal.com/newenglandarts": {"pid":"9430314"},
		"wickedlocal.com/newton": {"pid":"9430315"},
		"wickedlocal.com/norfolk": {"pid":"9430316"},
		"wickedlocal.com/northandover": {"pid":"9430317"},
		"wickedlocal.com/northattleborough": {"pid":"9430318"},
		"wickedlocal.com/northborough": {"pid":"9430319"},
		"wickedlocal.com/norton": {"pid":"9430320"},
		"wickedlocal.com/norwell": {"pid":"9430321"},
		"wickedlocal.com/norwood": {"pid":"9430322"},
		"wickedlocal.com/orleans": {"pid":"9430323"},
		"wickedlocal.com/pembroke": {"pid":"9430324"},
		"wickedlocal.com/plainville": {"pid":"9430325"},
		"wickedlocal.com/plymouth": {"pid":"9430326"},
		"wickedlocal.com/plympton": {"pid":"9430327"},
		"wickedlocal.com/provincetown": {"pid":"9430328"},
		"wickedlocal.com/quincy": {"pid":"9430329"},
		"wickedlocal.com/randolph": {"pid":"9430330"},
		"wickedlocal.com/raynham": {"pid":"9430331"},
		"wickedlocal.com/reading": {"pid":"9430332"},
		"wickedlocal.com/rehoboth": {"pid":"9430333"},
		"wickedlocal.com/rochester": {"pid":"9430334"},
		"wickedlocal.com/rockland": {"pid":"9430335"},
		"wickedlocal.com/rockport": {"pid":"9430336"},
		"wickedlocal.com/roslindale": {"pid":"9430337"},
		"wickedlocal.com/salem": {"pid":"9430338"},
		"wickedlocal.com/sandwich": {"pid":"9430339"},
		"wickedlocal.com/saugus": {"pid":"9430340"},
		"wickedlocal.com/scituate": {"pid":"9430341"},
		"wickedlocal.com/sharon": {"pid":"9430342"},
		"wickedlocal.com/sherborn": {"pid":"9430343"},
		"wickedlocal.com/shrewsbury": {"pid":"9430344"},
		"wickedlocal.com/somerset": {"pid":"9430345"},
		"wickedlocal.com/somerville": {"pid":"9430346"},
		"wickedlocal.com/southborough": {"pid":"9430347"},
		"wickedlocal.com/stoneham": {"pid":"9430348"},
		"wickedlocal.com/stoughton": {"pid":"9430349"},
		"wickedlocal.com/stow": {"pid":"9430350"},
		"wickedlocal.com/sudbury": {"pid":"9430351"},
		"wickedlocal.com/swampscott": {"pid":"9430352"},
		"wickedlocal.com/swansea": {"pid":"9430353"},
		"wickedlocal.com/taunton": {"pid":"9430354"},
		"wickedlocal.com/tewksbury": {"pid":"9430355"},
		"wickedlocal.com/topsfield": {"pid":"9430356"},
		"wickedlocal.com/truro": {"pid":"9430357"},
		"wickedlocal.com/upton": {"pid":"9430358"},
		"wickedlocal.com/wakefield": {"pid":"9430359"},
		"wickedlocal.com/walpole": {"pid":"9430360"},
		"wickedlocal.com/waltham": {"pid":"9430361"},
		"wickedlocal.com/wareham": {"pid":"9430362"},
		"wickedlocal.com/watertown": {"pid":"9430363"},
		"wickedlocal.com/wayland": {"pid":"9430364"},
		"wickedlocal.com/wellesley": {"pid":"9430365"},
		"wickedlocal.com/wellfleet": {"pid":"9430366"},
		"wickedlocal.com/wenham": {"pid":"9430367"},
		"wickedlocal.com/west-roxbury": {"pid":"9430368"},
		"wickedlocal.com/westborough": {"pid":"9430369"},
		"wickedlocal.com/westford": {"pid":"9430370"},
		"wickedlocal.com/weston": {"pid":"9430371"},
		"wickedlocal.com/westport": {"pid":"9430372"},
		"wickedlocal.com/westwood": {"pid":"9430373"},
		"wickedlocal.com/weymouth": {"pid":"9430374"},
		"wickedlocal.com/whitman": {"pid":"9430375"},
		"wickedlocal.com/wilmington": {"pid":"9430376"},
		"wickedlocal.com/winchester": {"pid":"9430377"},
		"wickedlocal.com/woburn": {"pid":"9430378"},
		"wickedlocal.com/wrentham": {"pid":"9430379"},
		"wickedlocal.com/yarmouth": {"pid":"9430380"},
		"wickedlocalparents.com": {"pid":"9430381"},
		"wickedlocalwebjams.com": {"pid":"9430382"},
		"wintersenterprise.com": {"pid":"9430383"},
		"wislawjournal.com": {"pid":"9430384"},
		"woodfordtimes.com": {"pid":"9430385"},
		"yourglenrosetx.com": {"pid":"9430386"},
		"yourstephenvilletx.com": {"pid":"9430387"},
		"yourvalleyvoice.com": {"pid":"9430388"}
	}
}

